<template>
  <v-container class="pa-0">
    <v-card
      ref="refComponent "
      class="ma-0 px-1 position-relative"
      :class="{ fullscreen: fullscreen }"
      width="100%"
      flat
    >
      <v-app-bar flat class="my-0 mb-2 py-1 px-4" dense height="40">
        <v-toolbar-title class="me-5">
          {{ !id ? $t(type) : $t("edit") + " " + $t(type) + " " + "(" + id + ")" }}
        </v-toolbar-title>
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-shortkey="['f10']"
              v-bind="attrs"
              icon
              width="35"
              class="float-left"
              v-on="on"
              @shortkey="fullScreenFunc"
              @click="fullScreenFunc"
            >
              <v-icon color="primary" style="font-size: 30px">
                {{ !fullscreen ? "mdi-fullscreen" : "mdi-fullscreen-exit" }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("fullscreen") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!isMobile && !id"
              v-bind="attrs"
              icon
              width="35"
              class="float-left"
              v-on="on"
              @click="getAllProductsOffline(type)"
            >
              <v-icon color="green" style="font-size: 30px"> mdi-sync </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("syncData") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!formType"
              v-bind="attrs"
              icon
              width="35"
              v-on="on"
              @click="goTo(type + 'List')"
            >
              <v-icon color="primary" style="font-size: 30px">
                mdi-format-list-numbered
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("list") }} {{ $t(type) }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!formType"
              v-bind="attrs"
              icon
              width="35"
              v-on="on"
              @click="configDialog = true"
            >
              <v-icon color="primary" style="font-size: 26px"> mdi-cog-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("setting") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!formType"
              v-bind="attrs"
              icon
              width="35"
              v-on="on"
              @click="$router.go(-1)"
            >
              <v-icon color="primary" style="font-size: 30px"> mdi-arrow-left </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("back") }}</span>
        </v-tooltip>
      </v-app-bar>
      <v-progress-linear
        :active="!render || loading"
        :indeterminate="!render || loading"
        absolute
        bottom
        style="top: -4px"
        color="primary"
      />
      <v-form v-if="render" ref="form" v-model="valid" lazy-validation>
        <v-tabs v-show="isMobile" v-model="tab">
          <v-tab>
            {{ $t("public-information") }}
          </v-tab>
          <!-- <v-tab>{{ $t('addtional-information') }}</v-tab> -->
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-container class="py-0 px-1" fluid>
              <v-row class="mx-0">
                <v-col
                  v-show="bodyStatus == false || !isMobile"
                  cols="12"
                  md="5"
                  sm="5"
                  class="px-0 pb-0"
                >
                  <products
                    ref="productCategoryRef"
                    v-model="items"
                    :data="JSON.stringify({ entrepot: entrepot ? entrepot.id : null })"
                    :item-count="items ? items.length : 0"
                    :height-prop="tableHeightInvoice"
                    :offline-prop="offline"
                    :type-prop="type"
                    :scale-prop="scale"
                    @append="append"
                    @setOffline="setOffline"
                  />
                </v-col>
                <v-col
                  v-show="bodyStatus == true || !isMobile"
                  cols="12"
                  md="6"
                  sm="6"
                  class="ps-0"
                >
                  <v-row class="my-2 mx-0 px-0">
                    <v-col
                      class="px-1 xs py-1"
                      cols="6"
                      :class="{ 'mb-3': isMobile }"
                      md="4"
                    >
                      <autocomplete
                        ref="refAccount"
                        v-model="account"
                        :title="$t('account')"
                        :type="offline ? 'getAllPersonOffline' : 'person'"
                        :offline="offline"
                        :set-offline="offline"
                        :new-btn="true"
                        :rules="[(v) => !!v || $t('is-required')]"
                        :value="account"
                      />
                    </v-col>
                    <v-col
                      class="py-1 pa-0"
                      cols="6"
                      md="4"
                      :class="{ 'mb-3': isMobile }"
                    >
                      <template>
                        <v-text-field
                          id="from"
                          v-model="date"
                          :label="$t('date')"
                          :rules="[(v) => !!v || $t('is-required')]"
                          clear-icon="flaticon2-close-cross"
                          outlined
                          hide-details
                          dense
                          clearable
                          ref="date"
                        />
                        <date-picker
                          v-model="date"
                          element="from"
                          :locale="$store.state.date_locale"
                          :format="$store.state.date_format"
                          auto-submit
                          :min="$store.state.startDate"
                          :max="$store.state.endDate"
                          :color="
                            this.$vuetify.theme.themes[
                              this.$vuetify.theme.isDark ? 'dark' : 'light'
                            ].primary
                          "
                          @close="setDate"
                        />
                      </template>
                    </v-col>
                    <v-col
                      class="py-1 pa-0 pr-1"
                      cols="6"
                      md="4"
                      :class="{ 'mb-3': isMobile }"
                    >
                      <autocomplete
                        ref="refEntrepot"
                        v-model="entrepot"
                        title="entrepot"
                        type="entrepot"
                        :set-init="id ? false : false"
                        :new-btn="true"
                        :value="entrepot"
                        :offline="offline"
                        :set-offline="offline"
                        @input="checkProductsCount"
                      />
                    </v-col>
                    <v-col
                      v-show="false"
                      cols="12"
                      sm="2"
                      md="2"
                      :class="{ 'mb-3': isMobile }"
                      class="py-1 pa-0"
                    >
                      <aicomplete
                        v-model="branch"
                        title="branch"
                        type="branch"
                        :set-init="true"
                        :val="branch"
                        :offline="offline"
                        :set-offline="offline"
                      />
                    </v-col>

                    <!-- <v-col
                      cols="6"
                      class="py-1 px-1"
                      md="2"
                    >
                      <v-text-field
                        v-model="number"
                        height="20"
                        dense
                        :rules="[v => !!v || $t('is-required')]"
                        outlined
                        class="mb-3 dense"
                        clearable
                        :label="$t('number')"
                        @blur="getInvoiceNumber"
                        @focus="focusEvent"
                        ref="number"
                      />
                    </v-col> -->

                    <!--  <v-col
                      class="px-1 xs py-1"
                      :class="{'mb-3' : isMobile}"
                      cols="6"
                      md="3"
                    >
                      <autocomplete
                        ref="refEntrepot"
                        v-model="entrepot"
                        title="entrepot"
                        type="entrepot"
                        :set-init="(id ? false : false)"
                        :new-btn="true"
                        :value="entrepot"
                        :offline="offline"
                        :set-offline="offline"
                        @input="checkProductsCount"
                      />
                    </v-col> -->
                  </v-row>
                  <v-row class="my-2 pt-5 mx-0 px-0">
                    <v-col class="px-0 py-0 border-datatable">
                      <v-row class="mx-0">
                        <v-col
                          ref="refScroll"
                          cols="12"
                          class="my-0 pa-0"
                          :style="{
                            height:
                              (isMobile
                                ? tableHeightInvoice + 65
                                : tableHeightInvoice + 70) + 'px',
                          }"
                          style="
                            zoom: 0.9;
                            overflow-y: scroll;
                            border-top: 1px solid #e3e3e3;
                            border-bottom: 1px solid #e3e3e3;
                            border-right: 1px solid #e3e3e3;
                            min-height: 300px;
                          "
                        >
                          <invoice-items
                            ref="refInvoiceItems"
                            v-model="items"
                            :items-prop="items"
                            :decimal="decimal"
                            :currency="currency"
                            :type="type"
                            :offline="offline"
                            :scale="scale"
                            :weight="weight"
                            @calc="calcSum"
                            @callrefbodyhight="setRefBody"
                            @setinputFocus="setFocus"
                            :errorIndexes="errorIndexes"
                            @itemRemoved="errorIndexesHandler"
                          />
                        </v-col>
                      </v-row>
                      <v-row class="mx-0">
                        <v-col cols="12" style="zoom: 0.9" class="mb-4 pa-0">
                          <!--v-simple-table-->
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="1" sm="1" class="px-0">
                  <v-text-field
                    v-model="number"
                    height="20"
                    dense
                    :rules="[(v) => !!v || $t('is-required')]"
                    outlined
                    class="my-3 dense"
                    clearable
                    :label="$t('number')"
                    @click="additionalDrawer = true"
                    @blur="getInvoiceNumber"
                    @focus="focusEvent"
                    ref="number"
                  />
                  <div v-if="!isMobile" style="width: 100%">
                    <!--   <v-text-field
                      v-model="numberForEdit"
                      height="20"
                      dense
                      class="mb-3 mx-0 mt-3 pt-2"
                      hide-details
                      outlined
                      type="number"
                      clearable
                      :label="$t('searchInvoice')"
                      @click:clear="clearableForm"
                      @focus="focusEvent"
                    /> -->
                  </div>
                  <v-btn
                    color="primary"
                    class="mx-0 mt-2"
                    height="32"
                    style="background-color: #818181 !important; width: 100%"
                    @click="searchInvDialog = true"
                  >
                    {{ $t("searchInvoice") }}
                  </v-btn>
                  <v-btn
                    class="mx-0 mt-2"
                    height="32"
                    style="background-color: #009688 !important; width: 100%"
                    block
                    @click="goToInvoice('prev')"
                  >
                    {{ $t("prevInvoice") }}
                  </v-btn>
                  <v-btn
                    class="mx-0 mt-2"
                    height="32"
                    style="background-color: #009688 !important; width: 100%"
                    :disabled="lastId && lastId >= currentId ? false : true"
                    @click="goToInvoice('next')"
                  >
                    {{ $t("nextInvoice") }}
                  </v-btn>
                  <v-btn
                    v-if="id"
                    color="teal"
                    height="38"
                    class="w-100 mt-2"
                    :loading="isLoading"
                    @click="goToInvoice('new')"
                  >
                    {{ $t("newInvoice") }}
                  </v-btn>
                  <v-btn
                    v-shortkey="['/']"
                    class="mx-0 mt-2"
                    height="32"
                    style="background-color: #ad1457 !important; width: 100%"
                    @shortkey="otherProduct"
                    @click="otherProduct"
                  >
                    {{ $t("otherProduct") }} (/)
                  </v-btn>
                  <v-btn
                    v-shortkey="['f8']"
                    color="blue"
                    class="mx-0 mt-2"
                    height="32"
                    style="background-color: #607d8b !important; width: 100%"
                    @shortkey="addProductDialog = true"
                    @click="addProductDialog = true"
                  >
                    {{ $t("defineProduct") }} (f8)
                  </v-btn>
                  <v-btn
                    color="teal"
                    height="38"
                    class="w-100 mt-2"
                    @click="additionalDrawer = true"
                  >
                    {{ $t("addtional-information") }}
                  </v-btn>
                </v-col>
              </v-row>
              <!--cach invoice-->
              <v-container class="pa-2 ma-0 fixed-bottom-payment">
                <v-container class="pa-0 d-flex align-center gap-2">
                  <div>
                    <v-container class="pa-0 d-flex align-center gap-2">
                      <v-btn
                        color="success"
                        :height="isMobile || isTablet ? auto : 50"
                        :width="isMobile || isTablet ? auto : 120"
                        @click="openOptionsDialog('cash-format')"
                      >
                        <my-icon
                          :name="'cash-icon'"
                          :width="19"
                          :height="19"
                          :cursor-pointer="true"
                        />
                        <span class="mr-1">{{ $t(resolveCompositeType()) }}</span>
                      </v-btn>
                      <v-btn
                        color="primary"
                        outlined
                        :height="isMobile || isTablet ? auto : 50"
                        :width="isMobile || isTablet ? auto : 120"
                        @click="sendToPosProcess('remain')"
                        :loading="posPending"
                      >
                        <my-icon
                          :name="'card-pos-icon'"
                          :width="15"
                          :height="15"
                          :cursor-pointer="true"
                        />
                        <span class="mr-1">{{ $t("send-to-pos") }}</span>
                      </v-btn>
                      <composite
                        :total="total"
                        :discount="discount"
                        :totalTax="totalTax"
                        @invoiceRemain="invoiceRemain"
                        @totalAmount="totalAmount"
                        :credit="credit"
                        :pos="true"
                        :currency="$store.state.currency"
                        :posesList="posesList"
                        :propType="resolveCompositeType()"
                        :propDate="date"
                        :account="account"
                        :optionDialogType="optionDialogType"
                        @closeOptionsDialog="optionDialogType = null"
                        @update="onTableUpdate"
                        :editCompositeTableData="editCompositeTableData"
                        :returnPosInfo="returnPosInfo"
                        @sendToPosProcess="sendToPosProcess"
                        :isPosSuccessfull="isPosSuccessfull"
                        @successAdded="isPosSuccessfull = false"
                      />
                    </v-container>
                    <v-container class="pa-0 d-flex align-center gap-2 mt-2">
                      <!--update-->
                      <v-btn
                        v-if="id != undefined || id != null"
                        v-shortkey="['f3']"
                        color="primary"
                        :height="isMobile || isTablet ? auto : 50"
                        :width="isMobile || isTablet ? auto : 120"
                        :loading="isLoading"
                        @shortkey="update"
                        @click="update"
                      >
                        <my-icon
                          :name="'bottom-left-cursor-icon'"
                          :width="15"
                          :height="15"
                          :cursor-pointer="true"
                        />
                        <span class="mr-1">{{ $t("edit") }}</span>
                      </v-btn>
                      <!--create-->
                      <v-btn
                        type="button"
                        v-shortkey="['f3']"
                        color="primary"
                        v-if="
                          (id == undefined || id == null) && !isMobile && !sellLinkProp
                        "
                        :height="isMobile || isTablet ? 'auto' : 50"
                        :width="isMobile || isTablet ? 'auto' : 120"
                        :loading="isLoading"
                        :disabled="isLoading"
                        @shortkey="(e) => create(null, e)"
                        @click="(e) => create(null, e)"
                      >
                        <my-icon
                          :name="'bottom-left-cursor-icon'"
                          :width="15"
                          :height="15"
                          :cursor-pointer="true"
                        />
                        <span class="mr-1">{{ $t("submit") }}</span>
                      </v-btn>
                      <!--create-->
                      <v-btn
                        v-if="
                          (id == undefined || id == null) && !isMobile && !sellLinkProp
                        "
                        type="button"
                        v-shortkey="['f5']"
                        color="secondary"
                        outlined
                        :loading="isLoading"
                        :height="isMobile || isTablet ? auto : 50"
                        :width="isMobile || isTablet ? auto : 120"
                        @shortkey="(e) => create('print', e)"
                        @click="(e) => create('print', e)"
                      >
                        <span style="color: #000">{{ $t("submit&Print") }}</span>
                      </v-btn>
                      <!--update-->
                      <v-btn
                        v-if="
                          (id != undefined || id != null) && !isMobile && !sellLinkProp
                        "
                        v-shortkey="['f5']"
                        color="secondary"
                        outlined
                        :loading="isLoading"
                        :height="isMobile || isTablet ? auto : 50"
                        :width="isMobile || isTablet ? auto : 120"
                        @shortkey="update('print')"
                        @click="update('print')"
                      >
                        <span style="color: #000">{{ $t("edit&Print") }}</span>
                      </v-btn>
                      <!--create-->
                      <v-btn
                        v-if="
                          (id == undefined || id == null) && !isMobile && !sellLinkProp
                        "
                        type="button"
                        v-shortkey="['f4']"
                        color="secondary"
                        outlined
                        :height="isMobile || isTablet ? auto : 50"
                        :width="isMobile || isTablet ? auto : 120"
                        :loading="isLoading"
                        @shortkey="(e) => create('printId', e)"
                        @click="(e) => create('printId', e)"
                      >
                        <span style="color: #000">{{ $t("submit&PrintId") }}</span>
                      </v-btn>
                      <!--update-->
                      <v-btn
                        v-if="
                          (id != undefined || id != null) && !isMobile && !sellLinkProp
                        "
                        v-shortkey="['f4']"
                        color="secondary"
                        outlined
                        :height="isMobile || isTablet ? auto : 50"
                        :width="isMobile || isTablet ? auto : 120"
                        :loading="isLoading"
                        @shortkey="update('printId')"
                        @click="update('printId')"
                      >
                        <span style="color: #000">{{ $t("edit&PrintId") }}</span>
                      </v-btn>
                    </v-container>
                  </div>
                  <div>
                    <v-card-text class="pa-0 text-body-2 mb-1">{{
                      $t("discount")
                    }}</v-card-text>
                    <v-container class="pa-0 ma-0 discount" style="width: 175px">
                      <money
                        v-model="discount"
                        :dense="true"
                        :outlined="true"
                        :solo="false"
                        :clearable="true"
                        value-when-is-empty="0"
                        :options="options"
                        class="mb-3 dense"
                        :append-icon="
                          !percentDiscountStatus ? 'mdi-percent-outline' : null
                        "
                        :disabled="
                          sum > 0 ? (percentDiscountStatus ? true : false) : true
                        "
                        @append="discountChangeStatus"
                        @input="checkTotalDiscount"
                      />
                      <v-text-field
                        v-if="percentDiscountStatus"
                        v-model="discountPercent"
                        append-icon="mdi-currency-usd"
                        placeholder="%"
                        class="ms-1"
                        height="20"
                        outlined
                        dense
                        type="number"
                        max="100"
                        min="0"
                        @keyup="discountCheck"
                        @blur="discountCheck"
                        @click:append="discountChangeStatus"
                      />
                    </v-container>
                    <v-card-text class="pa-0 text-body-2 mt-5">{{
                      $t("tax")
                    }}</v-card-text>
                    <v-container class="wrapper-toggle-tax mt-1 d-flex align-center pa-0">
                      <div
                        v-for="(item, index) in taxOption"
                        :key="index"
                        @click="selectTaxOption(item)"
                        class="child flex-fill text-center"
                        :style="{
                          'background-color':
                            selectedTaxOption == item.value ? '#0066ff' : '',
                          'border-color':
                            selectedTaxOption == item.value ? '#0066ff' : 'silver',
                          color: selectedTaxOption == item.value ? '#fff' : '',
                        }"
                      >
                        <v-card-text class="pa-0 text-body-2">{{
                          item.label
                        }}</v-card-text>
                      </div>
                    </v-container>
                  </div>
                  <div class="flex-fill">
                    <div class="header-total d-flex align-center py-1">
                      <v-container
                        v-if="hasCustomerClub && !id"
                        class="pa-0 pl-2"
                        style="border-left: 1px solid silver"
                      >
                        <div class="d-flex justify-space-between">
                          <div class="d-flex align-center gap-2">
                            <v-checkbox color="primary" v-model="credit_status">
                            </v-checkbox>
                            <v-card-text class="text-body-2 pa-0">{{
                              $t("club-credit")
                            }}</v-card-text>
                          </div>
                          <div class="d-flex align-center gap-1">
                            <v-btn
                              width="32"
                              height="32"
                              icon
                              :loading="isLoading"
                              color="secondary"
                            >
                              <v-icon
                                size="14"
                                style="cursor: pointer"
                                @click="fetchUserCredit"
                                color="secondary"
                              >
                                mdi-refresh
                              </v-icon>
                            </v-btn>
                            <v-card-text class="text-h5 pa-0">{{
                              $numberFormat(userCredit)
                            }}</v-card-text>
                            <v-card-text class="text-h5 pa-0">{{
                              $store.state.currency.symbol
                            }}</v-card-text>
                          </div>
                        </div>
                      </v-container>
                      <v-container class="pa-0 pr-2">
                        <div class="d-flex justify-space-between">
                          <v-card-text class="pa-0 text-body-1" style="color: #0066ff">{{
                            $t("sum-total")
                          }}</v-card-text>
                          <v-card-text class="pa-0 text-body-1" style="color: #0066ff"
                            >{{ $numberFormat(total) }}
                            {{ $store.state.currency.symbol }}</v-card-text
                          >
                        </div>
                      </v-container>
                    </div>
                    <div class="body-total d-flex align-center">
                      <v-container class="pa-2" style="border-left: 1px solid silver">
                        <div class="d-flex justify-space-between align-center">
                          <v-card-text class="pa-0 text-body-2">{{
                            $t("invoice-total")
                          }}</v-card-text>
                          <v-card-text class="pa-0 text-body-2">{{
                            $numberFormat(+total - +totalTax + +discount)
                          }}</v-card-text>
                        </div>
                        <div class="d-flex justify-space-between align-center my-1">
                          <v-card-text class="pa-0 text-body-2">{{
                            $t("tax-total")
                          }}</v-card-text>
                          <v-card-text class="pa-0 text-body-2">{{
                            $numberFormat(totalTax)
                          }}</v-card-text>
                        </div>
                        <div class="d-flex justify-space-between align-center">
                          <v-card-text class="pa-0 text-body-2">{{
                            $t("discount-total")
                          }}</v-card-text>
                          <v-card-text class="pa-0 text-body-2">{{
                            $numberFormat(discount)
                          }}</v-card-text>
                        </div>
                      </v-container>
                      <v-container class="pa-2">
                        <div class="d-flex justify-space-between align-center">
                          <v-card-text class="pa-0 text-body-2">{{
                            $t("count-of-ware")
                          }}</v-card-text>
                          <v-card-text class="pa-0 text-body-2">{{
                            $numberFormat(totalCount)
                          }}</v-card-text>
                        </div>
                        <div
                          class="d-flex justify-space-between align-center mt-1"
                          v-if="hasCustomerClub"
                        >
                          <v-card-text class="pa-0 text-body-2">{{
                            $t("club-credit")
                          }}</v-card-text>
                          <v-card-text class="pa-0 text-body-2">
                            {{
                              !id
                                ? $numberFormat(creditAmount)
                                : $numberFormat(prevCredit)
                            }}
                            {{ $store.state.currency.symbol }}
                          </v-card-text>
                        </div>
                        <div class="d-flex justify-space-between align-center my-1">
                          <v-card-text class="pa-0 text-body-2">{{
                            $t("payments-total")
                          }}</v-card-text>
                          <v-card-text class="pa-0 text-body-2">{{
                            totalPayment ? totalPayment.toLocaleString("fa-IR") : 0
                          }}</v-card-text>
                        </div>
                        <div class="d-flex justify-space-between align-center">
                          <v-card-text class="pa-0 text-body-2">{{
                            $t("remain")
                          }}</v-card-text>
                          <v-card-text class="pa-0 text-body-2">{{
                            $numberFormat(remainInvoice)
                          }}</v-card-text>
                        </div>
                      </v-container>
                    </div>
                  </div>
                  <div class="d-flex flex-column gap-2">
                    <v-btn color="error" outlined @click="goToInvoice('delete')">
                      <my-icon
                        :name="'trash-icon'"
                        :width="15"
                        :height="15"
                        :cursor-pointer="true"
                        :fill="'#ff5252'"
                      />
                      <span>{{ $t("delete-all-items") }}</span>
                    </v-btn>
                    <segment-display :value="weight" />
                  </div>
                </v-container>
              </v-container>
            </v-container>
          </v-tab-item>
          <!-- <v-tab-item style="height: 155px;">
            <v-row class="mx-0 mt-4">
              <v-col
                cols="12"
                class="py-1 px-1"
                md="2"
                sm="2"
                :class="{'mb-3' : isMobile}"
              >
                <template>
                  <v-text-field
                    id="dueDateId"
                    v-model="dueDate"
                    :label="$t('dueDate')"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    clearable
                    @keyup="dueDate = null"
                  />

                  <date-picker
                    v-model="dueDate"
                    element="dueDateId"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="date"
                    :max="$store.state.endDate"
                    :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col
                v-show="(type == 'presale' || type == 'sell'|| type == 'returnSell') && (bodyStatus == false || !isMobile)"
                cols="12"
                class="py-1 px-1"
                sm="2"
                md="2"
              >
                <v-text-field
                  v-model="officialNumber"
                  height="20"
                  dense
                  outlined
                  class="mb-3 dense"
                  clearable
                  :label="$t('officialNumber')"
                  @blur="getOfficialInvoiceNumber"
                />
              </v-col>
              <v-col
                class="py-1 px-1"
                cols="12"
                md="2"
                sm="2"
                style="height: 20px"
                :class="{'mb-5' : isMobile}"
              >
                <status
                  v-model="status"
                  :hideconfig="true"
                  :type="type"
                  :value="status"
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
                class="py-1 px-1"
                :class="{'mb-3' : isMobile}"
              >
                <tag
                  v-model="tag"
                  :solo="false"
                  :input="tag"
                  :height="25"
                />
              </v-col>
              <v-col
                v-show="showCurrency && !isMobile"
                cols="12"
                sm="2"
                md="2"
                class="py-1 px-1"
                :class="{'mb-3' : isMobile}"
              >
                <autocomplete
                  ref="refCurrency"
                  v-model="currency"
                  :rules="[v => !!v || $t('is-required')]"
                  :title="$t('currency')"
                  type="currency"
                  :init="defaultCurrency"
                  :value="currency"
                  :offline="offline"
                  :set-offline="offline"
                  @change="changeCurrency"
                />
              </v-col>
              <v-col
                v-show="showCurrency && !isMobile"
                cols="12"
                sm="2"
                md="2"
                :class="{'mb-0' : isMobile}"
                class="py-1 px-1"
              >
                <money
                  v-model="currency_amount"
                  :label="$t('currency-rate')"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  class="mb-3 dense"
                />
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                :class="{'mb-3' : isMobile}"
                class="py-1 px-1"
              >
                <aicomplete
                  v-model="branch"
                  title="branch"
                  type="branch"
                  :set-init="true"
                  :val="branch"
                  :offline="offline"
                  :set-offline="offline"
                />
              </v-col>
              <v-col
                cols="12"
                :class="{'mb-3' : isMobile}"
                md="2"
                sm="2"
                class="mb-0 px-1 py-1"
              >
                <v-select
                  v-model="type"
                  :label="$t('documentType')"
                  :items="typeItems"
                  :disabled="(this.$route.name === 'presaleEdit' || itemsProp ? false : true)"
                  height="30"
                  dense
                  outlined
                  item-value="value"
                  item-text="text"
                  item-disabled="disable"
                  @input="checkProductsCount"
                />
              </v-col>
              <v-col
                cols="12"
                :class="{'mb-3' : isMobile}"
                md="2"
                sm="2"
                class="mb-0 px-1 py-1"
              >
                <autocomplete
                  v-model="given"
                  :title="$t('accountGiven')"
                  :offline="offline"
                  :set-offline="offline"
                  type="given"
                />
              </v-col>
            </v-row>
          </v-tab-item> -->
        </v-tabs-items>
        <v-card-actions class="pt-0 px-3 pb-0" />
      </v-form>
      <v-dialog
        v-model="taskDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="90%"
      >
        <v-card>
          <v-col class="d-flex">
            <v-btn icon color="grey darken-2" @click="taskDialog = false">
              <v-icon class="close-hover" large> mdi-close </v-icon>
            </v-btn>
            <p class="mx-auto font-weight-medium mt-2">
              {{ $t("task") }}
            </p>
          </v-col>
          <v-row class="ma-0">
            <task
              task-type="account"
              :ref-id="refId"
              :task-id="taskId"
              @close="taskDialog = false"
            />
          </v-row>
          <v-card-actions />
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="printDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="90%"
      >
        <v-card>
          <v-col class="d-flex">
            <v-btn icon color="grey darken-2" @click="printDialog = false">
              <v-icon class="close-hover" large> mdi-close </v-icon>
            </v-btn>
            <p class="mx-auto font-weight-medium mt-2">
              {{ $t("task") }}
            </p>
          </v-col>
          <v-row class="ma-0">
            <v-col class="pb-2 px-2" cols="12">
              <print
                :data-prop="reportData"
                :report-prop="reportName"
                :resource-prop="reportName"
              />
            </v-col>
          </v-row>
          <v-card-actions />
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deletDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="400"
      >
        <v-card>
          <v-col>
            <v-btn icon class="close-hover" @click="deletDialog = false">
              <v-icon color="grey" large> mdi-close </v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
          </v-col>
          <v-col class="mt-3 pr-7">
            <p class="mx-auto font-weight-medium">
              {{ $t("are-you-sure-delete-this-case") }}
            </p>
          </v-col>
          <v-card-actions>
            <v-row class="ma-0">
              <v-col cols="6">
                <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                  {{ $t("remove") }}
                </v-btn>
                <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                  {{ $t("remove") }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  color="grey"
                  outlined
                  class="float-left"
                  @click="deletDialog = false"
                >
                  {{ $t("cancel") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogPriceChange"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        max-width="290"
      >
        <v-card>
          <v-card-title class="text-h5"> Use Google's location service? </v-card-title>

          <v-card-text>
            Let Google help apps determine location. This means sending anonymous location
            data to Google, even when no apps are running.
          </v-card-text>

          <v-card-actions>
            <v-spacer />

            <v-btn color="green darken-1" text @click="dialogPriceChange = false">
              {{ $t("yes") }}
            </v-btn>

            <v-btn color="pink darken-1" text @click="dialogPriceChange = false">
              {{ $t("no") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            <p style="color: white" class="text-center">
              {{ !lodingText ? $t("syncData") : $t(lodingText) }} ...
            </p>
            <v-progress-linear v-model="progressPercent" color="amber" height="5" />
            <div align="center">
              <p class="white--text mb-0">{{ progressPercent }} %</p>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="helpDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        :width="isMobile ? '100%' : '50%'"
      >
        <v-card>
          <v-col class="d-flex">
            <v-btn icon color="grey darken-2" @click="helpDialog = false">
              <v-icon class="close-hover" large> mdi-close </v-icon>
            </v-btn>
          </v-col>
          <v-card class="mx-auto" flat>
            <v-card-text>
              <div class="text--primary">
                {{ $t("indexCategoryHelpContent") }}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                outlined
                color="deep-purple accent-4"
                class="ms-2"
                @click="downloadTools"
              >
                {{ $t("downloadSoftware") }}
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card-actions />
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="configDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        :width="isMobile ? '100%' : '50%'"
      >
        <v-card class="pa-5" height="400">
          <v-container class="pa-0 d-flex justify-space-between mb-8">
            <v-card-text class="pa-0 text-body-1">{{ $t("setting") }}</v-card-text>
            <v-icon size="20" @click="configDialog = false" style="cursor: pointer"
              >mdi-close</v-icon
            >
          </v-container>
          <v-tabs v-model="activeTab" vertical>
            <v-tab class="justify-start">
              <img src="@/assets/cash-register/fast-access.png" />
              <v-card-text class="pa-0 text-body-2 ms-2">{{
                $t("fast-access")
              }}</v-card-text>
            </v-tab>
            <v-tab class="justify-start">
              <img src="@/assets/cash-register/pos.png" />
              <v-card-text class="pa-0 text-body-2 ms-2">{{
                $t("pos-device")
              }}</v-card-text>
            </v-tab>
            <v-tab class="justify-start">
              <img src="@/assets/cash-register/printer.png" />
              <v-card-text class="pa-0 text-body-2 ms-2">{{ $t("printer") }}</v-card-text>
            </v-tab>
            <v-tab class="justify-start" disabled>
              <img src="@/assets/cash-register/scales.png" />
              <v-card-text class="pa-0 text-body-2 ms-2">{{ $t("scale") }}</v-card-text>
            </v-tab>
            <v-tab class="justify-start" disabled>
              <img src="@/assets/cash-register/other-setting.png" />
              <v-card-text class="pa-0 text-body-2 ms-2">{{
                $t("otherSetting")
              }}</v-card-text>
            </v-tab>
            <!--fast access-->
            <v-tab-item>
              <v-card-text class="pa-0 text-body-1 mb-5">{{
                $t("dashboard")
              }}</v-card-text>
              <v-container class="pa-0 d-flex flex-column gap-2">
                <!-- <v-container class="box px-3 py-2">
                  <v-container class="pa-0 d-flex justify-space-between">
                    <div class="d-flex align-center gap-3">
                      <img src="@/assets/cash-register/fund.png" />
                      <div>
                        <v-card-text class="pa-0 text-body-2">{{ $t('default-cach') }}</v-card-text>
                        <v-card-text class="pa-0 text-caption mt-1" style="color: #747373;">برای تنظیم کردن میزان استفاده ترازو مقدار آن را صفر میکند</v-card-text>
                      </div>
                    </div>
                    <autocomplete
                      v-if="currency"
                      v-model="defaultCash"
                      :title="$t('cash')"
                      :currency-prop="currency.id"
                      type="bankCash"
                      class="mt-1"
                    />
                  </v-container>
                </v-container> -->
                <v-container class="box px-3 py-2">
                  <v-container class="pa-0 d-flex justify-space-between align-center">
                    <div class="d-flex align-center gap-3">
                      <img src="@/assets/cash-register/calculator.png" />
                      <div>
                        <v-card-text class="pa-0 text-body-2">{{
                          $t("calculator")
                        }}</v-card-text>
                      </div>
                    </div>
                    <v-btn
                      color="primary"
                      outlined
                      height="32"
                      @click="openCalculator"
                      disabled
                    >
                      {{ $t("unlock") }}
                    </v-btn>
                  </v-container>
                </v-container>
                <v-container class="box px-3 py-2">
                  <v-container class="pa-0 d-flex justify-space-between align-center">
                    <div class="d-flex align-center gap-3">
                      <img src="@/assets/cash-register/keyboard.png" />
                      <div>
                        <v-card-text class="pa-0 text-body-2">{{
                          $t("keyboard")
                        }}</v-card-text>
                      </div>
                    </div>
                    <v-btn
                      color="primary"
                      outlined
                      height="32"
                      @click="openWindowsKeyboard"
                      disabled
                    >
                      {{ $t("unlock") }}
                    </v-btn>
                  </v-container>
                </v-container>
              </v-container>
              <!-- <v-container class="pa-0 d-flex justify-end mt-5">
                <v-btn
                  color="error"
                  outlined
                  height="32"
                >
                {{ $t('delete-data-base') }}
                </v-btn>
              </v-container> -->
            </v-tab-item>
            <!--pos device-->
            <v-tab-item>
              <v-container class="pa-0 d-flex justify-space-between">
                <v-card-text class="pa-0 text-body-1 mb-5">{{
                  $t("pos-device")
                }}</v-card-text>
                <v-btn color="primary" outlined height="32" @click="openPosDialog('add')">
                  {{ $t("add-new-device") }}
                </v-btn>
              </v-container>
              <v-data-table
                :headers="posHeaders"
                :items="posItems"
                :items-per-page="-1"
                hide-default-footer
                :height="isMobile || isTablet ? 265 : 252"
                fixed-header
                class="pos-table"
              >
                <template v-slot:item.status="{ item, index }">
                  <v-checkbox
                    v-model="item.status"
                    :true-value="'active'"
                    :false-value="null"
                    @change="setActiveStatus(index)"
                  />
                </template>
                <template v-slot:item.title="{ item, index }">
                  {{ item.title }}
                </template>
                <template v-slot:item.posDevice="{ item }">
                  {{ item.posDevice.Name }}
                </template>
                <template v-slot:item.bank="{ item }">
                  {{ item.bank.name }}
                </template>
                <template v-slot:item.posPort="{ item }">
                  {{ item.posPort ? item.posPort : $t("haveNot") }}
                </template>
                <template v-slot:item.posIp="{ item }">
                  {{ item.posIp ? item.posIp : $t("haveNot") }}
                </template>
                <template v-slot:header.edit="{ header }">
                  <v-container
                    class="pa-0 d-flex align-center justify-space-between ma-0 gap-2"
                  >
                    {{ $t("edit") }}
                    <div
                      style="cursor: pointer"
                      @click="openDeletePermissionDialog('all')"
                    >
                      <my-icon
                        :name="'trash-icon'"
                        :width="15"
                        :height="15"
                        :cursor-pointer="true"
                        :fill="'#000'"
                      />
                    </div>
                  </v-container>
                </template>
                <template v-slot:item.edit="{ item, index }">
                  <v-container
                    class="pa-0 d-flex align-center ma-0 justify-space-between"
                  >
                    <div
                      style="cursor: pointer"
                      class="pr-2"
                      @click="openPosDialog('edit', item)"
                    >
                      <my-icon
                        :name="'edit-icon'"
                        :width="15"
                        :height="15"
                        :stroke="'#000'"
                        :cursor-pointer="true"
                      />
                    </div>
                    <div
                      style="cursor: pointer"
                      @click="openDeletePermissionDialog('single', item, index)"
                    >
                      <my-icon
                        :name="'trash-icon'"
                        :width="15"
                        :height="15"
                        :cursor-pointer="true"
                        :fill="'#000'"
                      />
                    </div>
                  </v-container>
                </template>
              </v-data-table>
            </v-tab-item>
            <!--printer-->
            <v-tab-item>
              <v-card-text class="pa-0 text-body-1 mb-5">{{ $t("printer") }}</v-card-text>
              <v-container class="pa-0 d-flex flex-column gap-2">
                <v-container class="box px-3 py-2" style="height: 70px">
                  <v-container class="pa-0 d-flex justify-space-between">
                    <v-card-text class="pa-0 text-body-2">{{
                      $t("choose-printer")
                    }}</v-card-text>
                    <div>
                      <v-autocomplete
                        v-model="selectedPrinter"
                        :rules="[(v) => !!v || $t('is-required')]"
                        :label="$t('chose-device')"
                        class="mt-2 printer-device"
                        outlined
                        :items="printerList"
                        item-text="Name"
                        item-value="Key"
                        return-object
                      />
                    </div>
                  </v-container>
                </v-container>
              </v-container>
            </v-tab-item>
            <v-tab-item></v-tab-item>
            <v-tab-item></v-tab-item>
          </v-tabs>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="addNewPosDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        :width="isMobile ? '100%' : '25%'"
      >
        <v-card class="pa-5">
          <v-form ref="posForm" v-model="valid">
            <v-container class="pa-0 d-flex justify-space-between align-center mb-8">
              <v-card-text class="pa-0 text-body-1">{{
                dialogType == "add" ? $t("new-pos-device") : $t("edit-pos-device")
              }}</v-card-text>
              <v-icon size="20" style="cursor: pointer" @click="addNewPosDialog = false"
                >mdi-close</v-icon
              >
            </v-container>
            <v-card-text class="pa-0 text-caption mb-7"
              >اطلاعات دستگاه پوز خود را وارد کنید</v-card-text
            >
            <v-text-field
              v-model="newPos.title"
              :label="$t('caption')"
              :rules="[(v) => !!v || $t('is-required')]"
              outlined
              dense
              clearable
              class="mt-2 mb-8"
            />
            <v-text-field
              v-model="newPos.posIp"
              :label="$t('PosIp')"
              outlined
              dense
              :rules="[(v) => !!v || $t('is-required')]"
              clearable
            />
            <v-text-field
              v-model="newPos.posPort"
              :label="$t('PosPort')"
              outlined
              dense
              clearable
              class="my-8"
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <autocomplete
              v-model="newPos.bank"
              :rules="[(v) => !!v || $t('is-required')]"
              :title="$t('chose-bank')"
              type="bankCash"
              class="mt-8"
            />
            <v-autocomplete
              v-model="newPos.posDevice"
              :rules="[(v) => !!v || $t('is-required')]"
              :label="$t('chose-device')"
              class="mt-8 pos-device"
              outlined
              :items="posesList"
              item-text="Name"
              item-value="Key"
              return-object
            />
            <v-container class="pa-0 d-flex align-center gap-2 mt-4">
              <v-btn color="primary" height="32" @click="checkValidation">
                {{ dialogType == "add" ? $t("confirm") : $t("edit") }}
              </v-btn>
              <v-btn color="secondary" outlined height="32">
                {{ $t("cancel") }}
              </v-btn>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deletePermissionDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        :width="isMobile ? '100%' : '25%'"
      >
        <v-card class="pa-5">
          <v-container class="pa-0 d-flex justify-space-between">
            <v-card-text class="pa-0 text-body-2">
              {{
                isAllItemsDelete
                  ? $t("are you sure you want to delete all items?")
                  : $t("Are you sure you want to delete this item ?")
              }}
            </v-card-text>
            <v-icon @click="deletePermissionDialog = false" style="cursor: pointer"
              >mdi-close</v-icon
            >
          </v-container>
          <v-container class="pa-0 d-flex gap-2 mt-7">
            <v-btn color="error" height="32" @click="removePosRecord">
              {{ $t("yes") }}
            </v-btn>
            <v-btn outlined height="32" @click="deletePermissionDialog = false">
              {{ $t("no") }}
            </v-btn>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="numpadDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="323"
      >
        <v-card style="background-color: #e3e3e3">
          <v-col class="d-flex pt-2 pb-0">
            <v-btn icon @click="numpadDialog = false">
              <v-icon class="close-hover" large color="grey"> mdi-close </v-icon>
            </v-btn>
          </v-col>
          <v-card-text class="pa-0">
            <div class="overflow-y-auto ma-1 mx-0 mt-0">
              <numpad :input="numpadValue" @save="setNumpad" />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snakbar"
        :color="snakbarColor ? snakbarColor : 'primary'"
        top
        :timeout="10000"
        style="z-index: 1000000000000 !important"
      >
        {{ snakbarText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
            {{ $t("close") }}
          </v-btn>
        </template>
      </v-snackbar>
      <!--<div
        v-show="bottomNavigation"
        class="text-center buttom-Button-sheet pa-2"
      >
        <v-btn
          v-if="!sellLinkProp && type === 'sell' "
          v-shortkey="['f6']"
          color="teal"
          height="38"
          class="me-2"
          :loading="isLoading"
          @shortkey="sendToPos"
          @click="sendToPos"
        >
          {{ $t('pos&submit') }} (f6)
        </v-btn>
        <v-btn
          v-if="(!id && !isMobile) && !sellLinkProp "
          v-shortkey="['f5']"
          color="primary"
          height="38"
          class="me-2"
          :loading="isLoading"
          @shortkey="create('print')"
          @click="create('print')"
        >
          {{ $t('submit&Print') }} (f5)
        </v-btn>
        <v-btn
          v-if="(!id && !isMobile) && !sellLinkProp "
          v-shortkey="['f4']"
          color="blue"
          height="38"
          class="me-2"
          :loading="isLoading"
          @shortkey="create('printId')"
          @click="create('printId')"
        >
          {{ $t('submit&PrintId') }} (f4)
        </v-btn>
        <v-btn
          v-if="id"
          color="blue"
          height="38"
          class="me-2"
          :loading="isLoading"
          @click="update('print')"
        >
          {{ $t('update&Print') }} (f4)
        </v-btn>
        <v-btn
          v-if="!id"
          v-shortkey="['f3']"
          height="38"
          style="background-color: #4CAF50 !important;"
          :loading="isLoading"
          @shortkey="create"
          @click="create"
        >
          {{ $t('submit') }} (f3)
        </v-btn>
        <v-btn
          v-if="id"
          v-shortkey="['f3']"
          color="primary"
          height="38"
          :loading="isLoading"
          @shortkey="update"
          @click="update"
        >
          {{ $t('edit') }} (f3)
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="id"
          color="teal"
          height="38"
          class="mx-3"
          :loading="isLoading"
          @click="clearForm"
        >
          {{ $t('newInvoice') }}
        </v-btn>
        <v-btn
          color="pink"
          height="38"
          :loading="isLoading"
          @click="clearAllItems"
        >
          {{ $t('removeAllItems') }}
        </v-btn>
      </div>-->
      <Confirm ref="confirm" />
      <div ref="refPrint" style="display: none">
        <index-print
          :account-prop="account"
          :date-prop="date"
          :items-prop="items"
          :sum-prop="total"
          :total-discount="totalDiscount"
          :total-tax="totalTax"
          :id-prop="idPrint"
          :number-prop="number"
          :status-prop="printStatus"
          :content-prop="content"
          :branch-prop="branch"
          :user-info-prop="userInfo"
        />
      </div>
      <v-dialog
        v-model="addProductDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="95%"
      >
        <v-card>
          <v-col class="d-flex pt-2 pb-0">
            <v-btn icon @click="addProductDialog = false">
              <v-icon class="close-hover" large color="grey"> mdi-close </v-icon>
            </v-btn>
          </v-col>
          <v-card-text class="pa-0">
            <div class="overflow-y-auto ma-2 mx-0 mt-0" style="height: 400px">
              <product
                v-model="newProduct"
                :invoice-trigger="true"
                form-type="product"
                @addproduct="addProductFromDialog"
              />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--permission-->
      <v-dialog
        v-model="askPermissionDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="300"
      >
        <v-card class="pa-5">
          <v-container class="pa-0 d-flex justify-center">
            <v-icon size="70" color="warning">mdi-alert-circle-outline</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-1 text-center my-3">
            {{
              visitType == "prev"
                ? $t("are you sure you want to go to prev invoice?")
                : visitType == "next"
                ? $t("are you sure you want to go to next invoice?")
                : visitType == "new"
                ? $t("are you sure you want to create new invoice?")
                : visitType == "delete"
                ? $t("are you sure you want to delete all items?")
                : visitType == "localstorage"
                ? $t("do you want to continue with the lastest product you added ?")
                : ""
            }}
          </v-card-text>
          <v-container class="pa-0 d-flex justify-center align-center gap-2">
            <v-btn
              color="primary"
              height="32"
              @click="
                visitType == 'prev'
                  ? prevInvoice()
                  : visitType == 'next'
                  ? nextInvoice()
                  : visitType == 'new'
                  ? clearForm()
                  : visitType == 'delete'
                  ? clearAllItems()
                  : visitType == 'localstorage'
                  ? (restoreItems = true)
                  : ''
              "
            >
              {{ $t("yes") }}
            </v-btn>
            <v-btn color="error" height="32" @click="askPermissionDialog = false">
              {{ $t("no") }}
            </v-btn>
          </v-container>
        </v-card>
      </v-dialog>
      <!--render-pos-error-->
      <v-dialog
        v-model="posErrorDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="450"
        persistent
      >
        <v-card class="pa-5">
          <v-container class="pa-0 d-flex justify-center">
            <v-icon size="60" color="error">mdi-close-circle</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-center mt-4">
            <span class="text-body-1" style="font-size: 14.5pt !important">
              {{ $t("transition-failed") }}
            </span>
            <br />
            <span class="text-body-2" style="color: silver; font-size: 10.5pt !important">
              {{ posErrorTxt }}
            </span>
          </v-card-text>
          <div class="d-flex align-center justify-space-between mt-5">
            <div class="d-flex align-center gap-2">
              <v-btn
                height="33.5"
                color="primary"
                class="flex-fill"
                @click="startPosProsess"
              >
                <v-icon size="15" class="ml-1">mdi-refresh</v-icon>
                <span>{{ $t("try-again") }}</span>
              </v-btn>
              <v-btn
                height="33.5"
                color="primary"
                outlined
                @click="editInv"
                class="flex-fill"
                :loading="performingInv"
              >
                <my-icon
                  :name="'edit-icon'"
                  :width="18"
                  :height="18"
                  :cursor-pointer="true"
                  :stroke="'#0066ff'"
                  class="ml-1"
                />
                <span>{{ $t("edit-invoice") }}</span>
              </v-btn>
            </div>
            <div>
              <v-btn
                height="33.5"
                color="error"
                outlined
                @click="removeInv"
                :loading="performingInv"
                class="flex-fill"
              >
                <my-icon
                  :name="'trash-icon'"
                  :width="17"
                  :height="17"
                  :cursor-pointer="true"
                  class="ml-1"
                  :fill="'#ff5252'"
                />
                <span>{{ $t("remove-invoice") }}</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <!--print preview-->
      <v-dialog
        v-model="printPreviewDialog"
        :fullscreen="isMobile"
        :hide-overlay="isMobile"
        width="600"
      >
        <v-card class="pa-5">
          <v-radio-group v-model="printType" row hide-details>
            <v-radio class="mr-0" :label="$t('A4')" value="a4" />
            <v-radio :label="$t('invoiceRollprint')" value="fish" />
          </v-radio-group>
          <div v-if="printType == 'a4'"></div>
          <div v-if="printType == 'fish'">salam fish</div>
        </v-card>
      </v-dialog>
    </v-card>
    <v-navigation-drawer
      width="22%"
      class="pa-4"
      v-model="additionalDrawer"
      temporary
      app
    >
      <div class="d-flex justify-space-between align-center">
        <v-icon size="15" @click="additionalDrawer = false"> mdi-close </v-icon>
        <v-card-text class="pa-0 text-body-1">
          {{ $t("addtional-information") }}
        </v-card-text>
      </div>

      <div class="mt-7" :class="{ 'mb-3': isMobile }">
        <v-text-field
          v-model="number"
          height="20"
          dense
          :rules="[(v) => !!v || $t('is-required')]"
          outlined
          class="my-3 dense"
          clearable
          :label="$t('number')"
          @blur="getInvoiceNumber"
          @focus="focusEvent"
          ref="number"
        />
        <div class="pt-3">
          <textarea
            :placeholder="$t('description')"
            v-model="content"
            rows="5"
            style="
              border: 1px solid silver;
              width: 100%;
              border-radius: 4px;
              padding: 6px 9px 0 0;
            "
          />
        </div>
      </div>
      <div :class="{ 'mb-3': isMobile }">
        <template>
          <v-text-field
            id="dueDateId"
            v-model="dueDate"
            :label="$t('dueDate')"
            clear-icon="flaticon2-close-cross"
            outlined
            dense
            clearable
            @keyup="dueDate = null"
          />

          <date-picker
            v-model="dueDate"
            element="dueDateId"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            auto-submit
            :min="date"
            :max="$store.state.endDate"
            :color="
              this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light']
                .primary
            "
            @close="setDate"
          />
        </template>
      </div>
      <div
        class="mt-6"
        v-show="
          (type == 'presale' || type == 'sell' || type == 'returnSell') &&
          (bodyStatus == false || !isMobile)
        "
      >
        <v-text-field
          v-model="officialNumber"
          height="20"
          dense
          outlined
          class="mb-3 dense"
          clearable
          :label="$t('officialNumber')"
          @blur="getOfficialInvoiceNumber"
        />
      </div>
      <div class="mt-6" :class="{ 'mb-5': isMobile }">
        <status v-model="status" :hideconfig="true" :type="type" :value="status" />
      </div>
      <div class="mt-6" :class="{ 'mb-3': isMobile }">
        <tag v-model="tag" :solo="false" :input="tag" :height="25" />
      </div>
      <div class="mt-6" v-show="showCurrency && !isMobile" :class="{ 'mb-3': isMobile }">
        <autocomplete
          ref="refCurrency"
          v-model="currency"
          :rules="[(v) => !!v || $t('is-required')]"
          :title="$t('currency')"
          type="currency"
          :init="defaultCurrency"
          :value="currency"
          :offline="offline"
          :set-offline="offline"
          @change="changeCurrency"
        />
      </div>
      <div class="mt-6" v-show="showCurrency && !isMobile" :class="{ 'mb-0': isMobile }">
        <money
          v-model="currency_amount"
          :label="$t('currency-rate')"
          :dense="true"
          :outlined="true"
          :solo="false"
          :clearable="true"
          value-when-is-empty=""
          :options="options"
          class="mb-3 dense"
        />
      </div>
      <div class="mt-6" :class="{ 'mb-3': isMobile }">
        <aicomplete
          v-model="branch"
          title="branch"
          type="branch"
          :set-init="true"
          :val="branch"
          :offline="offline"
          :set-offline="offline"
        />
      </div>
      <div class="mt-6" :class="{ 'mb-3': isMobile }">
        <v-select
          v-model="type"
          :label="$t('documentType')"
          :items="typeItems"
          :disabled="!!id"
          height="30"
          dense
          outlined
          item-value="value"
          item-text="text"
          item-disabled="disable"
          @input="checkProductsCount"
        />
      </div>
      <div class="mt-6" :class="{ 'mb-3': isMobile }">
        <autocomplete
          v-model="given"
          :title="$t('accountGiven')"
          :offline="offline"
          :set-offline="offline"
          type="given"
        />
      </div>
    </v-navigation-drawer>
    <InvoiceSearch
      :isDialogVisible="searchInvDialog"
      @searchInvClosed="searchInvDialog = false"
      :invoiceType="invoiceType"
      @onSelectedRow="selectRowHandler"
    />
  </v-container>
</template>
<script>
import Task from "../task/task";
import General from "../../../../Mixins/general";
import autocomplete from "../../components/general/patial/autocomplete";
import Description from "../../components/general/description/Description";
import print from "./../../components/general/printViewer/printViewer";
import segmentDisplay from "./../../components/general/7segment/index.vue";
import indexPrint from "./indexCategoryPrint.vue";
import Composite from "./partial/Composite.vue";
import moment from "moment-jalaali";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import InvoiceSearch from "@/views/dashboard/pages/invoice/CashRegister/partial/InvoiceSearch.vue";

import Product from "./../product/product(old).vue";
import invoiceItems from "./partial/indexCategoryItems(old).vue";

function initialData() {
  return {
    lastId: null,
    currentId: 0,
    createIdInvoice: null,
    otherProductCounter: 1,
    pattern: 1,
    selected: [],
    configDialog: false,
    addProductDialog: false,
    helpDialog: false,
    bottomNavigation: true,
    defaultCash: null,
    numpadDialog: null,
    numpadValue: null,
    selectedItemNumpad: null,
    newProduct: null,
    paymentAmount: null,
    cashAmount: null,
    paymentByPos: null,
    customPaymentAmount: false,
    lodingText: null,
    idPrint: null,
    printStatus: "print",
    fullscreen: false,
    searchBarcode: null,
    numberForEdit: null,
    abrName: null,
    weight: null,
    tab: null,
    scale: false,
    uid: null,
    ouid: null,
    redirectUrl: true,
    websocketWeight: false,
    checkDiscountEdit: false,
    abrironPrinter: false,
    render: true,
    validBank: true,
    selectRow: null,
    given: null,
    offlineSaveStatus: null,
    offline: false,
    nextPermission: false,
    officialNumber: null,
    tableHeightInvoice: 380,
    showCurrency: true,
    reportData: null,
    reportName: null,
    plan: null,
    percentDiscountStatus: false,
    bodyStatus: false,
    dialogPriceChange: false,
    allowPriceChange: false,
    invoicePrintType: "normal",
    printDialog: false,
    discountEdit: 0,
    checkNumber: false,
    checkOfficialNumber: false,
    deletDialog: false,
    showClearing: true,
    showSelect: false,
    showProductList: false,
    clearingStatus: false,
    filter: false,
    valid: true,
    number: null,
    bank: null,
    entrepot: null,
    payments: null,
    checks: null,
    account: null,
    dueDate: null,
    date: null,
    currency_amount: null,
    content: null,
    model: null,
    printType: "fish",
    from: 1,
    taskDialog: null,
    id: null,
    status: null,
    tag: null,
    currency: null,
    temp: null,
    taxPercent: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    _hydratingItems: false,
    typeItems: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 1000,
    isLoading: false,
    snakbar: false,
    type: "sell",
    taskId: null,
    snakbarText: null,
    loading: true,
    tableOptions: {
      itemsPerPage: 1000,
    },
    headers: null,
    search: null,
    discountPercent: false,
    taxStatus: false,
    totalCount: 0,
    discount: 0,
    totalDiscount: 0,
    totalTax: 0,
    totalFee: 0,
    sumRow: 0,
    sum: 0,
    appendTimer: 0,
    decimal: 0,
    weightInterval: null,
    autoPrint: true,
    totalDiscountType: false,
    itemsTableBodyHeight: 300,
    barcodeQueue: [],
    processingBarcode: false,
    barcodeInputThreshold: 300,
    lastKeypressTime: 0,
    barcode: "",
    selectedTaxOption: "deactive",
    remainInvoice: null,
    totalPayment: null,
    posHeaders: [],
    posItems: [],
    isPosActive: false,
    addNewPosDialog: false,
    newPos: {
      title: null,
      posDevice: null,
      posIp: null,
      posPort: null,
      bank: null,
      status: null,
    },
    dialogType: null,
    selectedIndex: null,
    optionDialogType: null,
    compositeTableData: null,
    editCompositeTableData: null,
    deletePermissionDialog: false,
    deletedIndex: null,
    isAllItemsDelete: false,
    posesList: [],
    posPending: false,
    selectedPrinter: null,
    activeTab: 0,
    printerList: [],
    POSIP: null,
    POSPORT: null,
    progressPercent: 0,
    returnPosInfo: null,
    isPosSuccessfull: false,
    compositeAmount: null,
    socketPrintRes: null,
    credit_status: false,
    idUser: null,
    userCredit: 0,
    credit: null,
    prevCredit: null,
    askPermissionDialog: false,
    visitType: null,
    additionalDrawer: false,
    errorIndexes: null,
    savedItems: null,
    restoreItems: false,
    printPreviewDialog: false,
    invoiceSubmited: false,
    searchInvDialog: false,
    invoiceType: null,
    posErrorDialog: false,
    posErrorTxt: null,
    performingInv: false,
    uidLastInv: null,
    selectedBank: null,
    currentVersion: null,
    userInfo: null,
  };
}
export default {
  name: "InvoiceIndex",
  components: {
    Products: () =>
      import("../../components/general/Products/ProductsWithCategory(old).vue"),
    numpad: () => import("../../components/general/numpad/index(old).vue"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    invoiceItems,
    Description,
    indexPrint,
    Product,
    print,
    segmentDisplay,
    autocomplete,
    Task,
    Composite,
    MyIcon,
    InvoiceSearch,
  },
  mixins: [General],
  props: [
    "input",
    "formType",
    "refId",
    "accountProp",
    "itemsProp",
    "sellLinkProp",
    "returnSellProp",
  ],
  data: function () {
    return initialData();
  },
  computed: {
    total: function () {
      var sum =
        parseFloat(this.sum) -
        parseFloat(this.totalDiscount !== "" ? this.totalDiscount : 0);
      this.checkBankRemain(sum);
      return sum.toFixed(this.decimal);
    },
    taxOption() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    creditAmount() {
      if (this.credit_status) {
        if (Number(this.userCredit) <= Number(this.total)) {
          this.credit = Number(this.userCredit);
          return Number(this.userCredit);
        } else if (Number(this.userCredit) > Number(this.total)) {
          this.credit = Number(this.total);
          return Number(this.total);
        }
      } else {
        this.credit = 0;
        return 0;
      }
    },
  },
  created() {
    this.savedItems = localStorage.getItem("items");
    if (this.savedItems && this.savedItems.length > 0) {
      this.askPermissionDialog = true;
      this.visitType = "localstorage";
    }
  },
  sockets: {
    getValue: function (data) {
      this.weight = data;
    },
  },
  watch: {
    type(val) {
      this.invoiceType = val;
    },
    printType(val) {
      console.log(val);
    },
    restoreItems(val) {
      if (val) {
        this._hydratingItems = true;
        try {
          this.items = JSON.parse(this.savedItems);
        } catch (e) {}
        this.$nextTick(() => {
          this._hydratingItems = false;
        });
        this.askPermissionDialog = false;
      } else {
        this.items = [];
        this.askPermissionDialog = false;
      }
    },
    socketPrintRes: {
      handler(val) {
        if (val && val.status == "Printed" && val.type == "create") {
          this.clearForm();
        }
        if (val && val.status == "Printed" && val.type == "update") {
          this.clearableForm();
        }
      },
      immediate: true,
      deep: true,
    },
    addProductDialog(val) {
      if (val) {
        // this.$store.commit('SET_AUTOFOCUS', false)
      } else {
        // this.$store.commit('SET_AUTOFOCUS', true)
        // this.$store.commit('SET_PREINPUT', null)
        // this.$refs.productCategoryRef.setFocus()
      }
    },
    cashAmount(val) {
      if (val && !this.defaultCash) {
        this.configDialog = true;
        this.snakbarText = this.$t("pleaseSelectCashForCashPayment");
        this.snakbarColor = "blue";
        this.snakbar = true;
      }
      if (val) {
        var remain = +this.total - +val;
        if (remain > 0) {
          this.paymentAmount = remain;
        }
      }
    },
    defaultCash(val) {
      localStorage.setItem("defaultCash", JSON.stringify(val));
      this.bank = this.defaultCash;
    },
    total(val) {
      this.paymentAmount = val;
    },
    customPaymentAmount(val) {
      this.paymentAmount = this.total;
    },
    returnSellProp(val) {
      this.onResize();
    },
    abrironPrinter(val) {
      localStorage.setItem("abrironPrinter", val);
    },
    showProductList(val, oldVal) {
      if (val) {
        localStorage.setItem("showProductListInvoice", val);
      } else {
        localStorage.removeItem("showProductListInvoice");
      }
    },
    account(val) {
      if (!this.id) {
        localStorage.setItem("defaultAccount", JSON.stringify(val));
      }
      if (val) {
        if (val.customer_club_credit && val.customer_club_credit.length > 0) {
          this.userCredit = Number(val.customer_club_credit[0].value || 0);
        } else {
          this.userCredit = 0;
        }
        this.idUser = val.id;
        // if (this.idUser) {
        //   this.fetchUserCredit();
        // }
      }
    },
    items: {
      deep: true,
      handler(val) {
        if (this._hydratingItems) return;
        localStorage.setItem("items", JSON.stringify(val));
      },
    },
    currency(val, old) {
      this.decimal = 0;
      if (val) {
        this.decimal = val.decimal;
        if (this.render) {
          this.currency_amount = val.amount;
          this.bank = null;
        }
      } else {
        this.currency_amount = null;
      }
      if (this.render) {
        // this.clearRows()
      }
    },
    taxStatus(val, old) {
      if (val) {
        this.totalDiscountType = false;
        this.totalDiscount = 0;
        this.discount = 0;
      }
      this.calcSum();
    },
    taxPercent(val, old) {
      if (this.taxStatus) {
        this.totalDiscountType = false;
        this.totalDiscount = 0;
        this.discount = 0;
      }
      this.calcSum();
    },
    defaultCurrency() {
      if (this.defaultCurrency && !this.id) {
        this.$refs.refCurrency.setModel(this.defaultCurrency);
        this.currency_amount = this.defaultCurrency.amount;
      }
    },
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected?.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0]?.text;
        this.temp = this.selected[0]?.text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    payments: {
      handler() {
        var app = this;
        app.showClearing = true;
        if (app.payments && app.payments.length > 0) {
          app.payments.map(function (value, key) {
            if (value.chip) {
              app.showClearing = false;
              app.clearingStatus = false;
              app.bank = null;
            }
          });
        }
        // app.checks.map(function (value, key) {
        //   if (value.chip) {
        //     app.showClearing = false
        //     app.clearingStatus = false
        //     app.bank = null
        //   }
        // })
      },
      deep: true,
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.tableOptions.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    itemsProp(val) {
      if (val) {
        this.items = val;
      } else {
        this.items = [];
        this.addRow();
      }
    },
    offline() {
      if (this.offline && !this.callInvoiceByNumber) {
        this.getInvoiceNumberOffline();
      } else {
        this.getInvoiceNumber();
      }
      this.setCookie("offlineInvoice", this.offline);
    },
    scale(val) {
      if (val && val === "active") {
        this.getWeight();
      } else {
        this.stopWeight();
      }
    },
    activeTab(val) {
      if (val && val == 2) {
        this.getPrinterListBySocket();
      }
    },
    selectedPrinter(val) {
      localStorage.setItem("selectedPrinter", val);
    },
  },
  activated: function () {
    this.beforeMount();
  },
  beforeMount() {
    this.posHeaders = [
      {
        text: this.$t("active"),
        align: "start",
        sortable: false,
        value: "status",
        width: 30,
      },
      {
        text: this.$t("device-title"),
        align: "start",
        sortable: false,
        value: "title",
      },
      {
        text: this.$t("posType"),
        align: "start",
        sortable: false,
        value: "posDevice",
      },
      {
        text: this.$t("bank"),
        align: "start",
        sortable: false,
        value: "bank",
      },
      {
        text: this.$t("PosIp"),
        align: "start",
        sortable: false,
        value: "posIp",
      },
      {
        text: this.$t("PosPort"),
        align: "start",
        sortable: false,
        value: "posPort",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
      },
    ];
    // this.beforeMount()
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("token"));
    this.checkSystemUpdate();
    this.getPosInfo();
    this.getSocketVersion();

    this.invoiceType = this.type;

    var app = this;
    if (this.$route.name === "invoiceCasher") {
      this.type = "sell";
    }
    if (this.$route.name === "returnSellCasher") {
      this.type = "returnSell";
    }
    if (this.$route.name === "purchase") {
      this.type = "purchase";
    }
    if (this.$route.name === "returnPurchase") {
      this.type = "returnPurchase";
    }
    if (this.$route.name === "returnSell") {
      this.type = "returnSell";
    }
    // this.offline = true
    if (localStorage.getItem("showProductListInvoice")) {
      this.showProductList = true;
    }
    if (localStorage.getItem("abrironPrinter")) {
      this.abrironPrinter = localStorage.getItem("abrironPrinter");
    }
    if (localStorage.getItem("defaultCash")) {
      this.defaultCash = JSON.parse(localStorage.getItem("defaultCash"));
      this.bank = this.defaultCash;
    }
    if (localStorage.getItem("posDevice")) {
      this.posItems = JSON.parse(localStorage.getItem("posDevice"));
    }
    this.taxPercent = this.$store.state.tax;
    this.headers = [
      {
        text: this.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 40,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 40,
      },
      {
        text: this.$t("product") + "/" + this.$t("service"),
        sortable: false,
        value: "product",
        width: 300,
      },
      {
        text: this.$t("unit"),
        sortable: false,
        value: "unit",
        width: 140,
      },
      {
        text: this.$t("count"),
        sortable: false,
        value: "count",
        width: 200,
      },
      {
        text: this.$t("fee"),
        sortable: false,
        value: "fee",
        width: 200,
      },
      {
        text: this.$t("discount"),
        sortable: false,
        value: "discount",
        width: 230,
      },
      {
        text: this.$t("tax"),
        sortable: false,
        value: "tax",
        width: 160,
      },
      {
        text: this.$t("sum"),
        sortable: false,
        value: "sum",
        width: 170,
      },
    ];
    var presaleDisable = false;
    if (this.$route.name === "presaleEdit" && this.id) {
      presaleDisable = true;
    }
    this.typeItems = [
      {
        value: "sell",
        text: this.$t("sell"),
      },
      {
        value: "presale",
        text: this.$t("presale"),
      },
      {
        value: "returnSell",
        text: this.$t("returnSell"),
        disable: presaleDisable,
      },
      {
        value: "purchase",
        text: this.$t("purchase"),
        disable: presaleDisable,
      },
      {
        value: "returnPurchase",
        text: this.$t("returnPurchase"),
        disable: presaleDisable,
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.loading = false;
    if (this.$route.params.id === null || this.$route.params.id === undefined) {
      // this.addRow()
      // this.currency = this.$store.state.currency
      // this.currency_amount = this.$store.state.currency.amount
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    if (this.isMobile) {
      this.printType = "fish";
    }
    // this.getAllProductsOffline(app.type)
    // this.getAllPersonOffline()
    this.getAbrOffline();
    if (app.type === "returnSell") {
      this.$root.$on("createReturnSell", () => {
        app.redirectUrl = false;
        app.create();
      });
    }
    // app.getWeight()
    app.setDefaultCooki();
    var invoiceluncher = localStorage.getItem("invoiceLuncher");
    if (!invoiceluncher) {
      localStorage.setItem("invoiceLuncher", "dbCreated");
    }
    if (invoiceluncher === "dbCreated") {
      localStorage.setItem("invoiceLuncher", "dataSet");
      this.getAllProductsOffline("product");
      this.$store.commit("SET_RELOAD", true);
      this.helpDialog = true;
    }
    var defaultAccount = localStorage.getItem("defaultAccount");
    if (defaultAccount) {
      this.account = JSON.parse(defaultAccount);
    }
    window.addEventListener("keydown", this.handleBarcodeScannerInput);
    this.selectedPrinter = localStorage.getItem("selectedPrinter");
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("keydown", this.handleBarcodeScannerInput);
  },
  methods: {
    checkSystemUpdate() {
      var app = this;
      app.loading = true;

      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            os: "windows",
            select: "getVersion",
          },
        })
        .then((r) => {
          if (r.data && r.data.version) {
            app.currentVersion = r.data.version;

            const socket = new WebSocket("ws://127.0.0.1:8145/Update");

            socket.onopen = function () {
              console.log("Socket connected");
              const message = {
                LatestVersion: app.currentVersion,
              };
              socket.send(JSON.stringify(message));
            };

            socket.onmessage = function (event) {
              console.log("Response from server:", event.data);
            };

            socket.onerror = function (error) {
              console.error("Socket error:", error);
            };

            socket.onclose = function () {
              console.log("Socket closed");
            };
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    resolveCompositeType() {
      if (
        this.invoiceType == "sell" ||
        this.invoiceType == "presale" ||
        this.invoiceType == "returnPurchase"
      ) {
        return "recieve";
      } else {
        return "pay";
      }
    },
    removeInv() {
      var app = this;
      app.performingInv = true;
      app.$axios
        .delete(app.$apipoint + `v2/invoice/${app.lastId}`)
        .then((r) => {
          if (r.data.message) {
            app.clearForm();
            setTimeout(function () {
              app.getLastInvoiceNumber();
            }, 100);
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.deleteItem = null;
        });
    },
    getLastInvoiceNumber() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            type: app.type,
            select: "getInvoiceNumber",
          },
        })
        .then((r) => {
          if (r.data) {
            app.number = r.data.number;
            app.performingInv = false;
            app.posErrorDialog = false;
            app.posPending = false;
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    editInv() {
      this.performingInv = true;
      this.id = this.uidLastInv;
      this.show();
    },
    submitRecieve() {
      var app = this;
      app.$axios
        .post(this.$endpoint + "payments", {
          account: app.account,
          amount: app.returnPosInfo.amount,
          date: app.date,
          bank: app.selectedBank,
          type: app.resolveCompositeType(), // recieve or pay
          branch: app.branch,
          currency: app.currency,
          currency_amount: app.currency_amount,
          relations: [
            {
              id: app.lastId,
              number: app.number,
              doc_type: app.type, // sell , purchase , ...
            },
          ],
        })
        .then((r) => {
          if (r.data.message) {
            app.print("create");
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    selectRowHandler(selectedRow) {
      if (selectedRow && selectedRow.uid) {
        this.id = selectedRow.uid;
        this.show();
        this.searchInvDialog = false;
      }
    },
    submitPreview() {
      this.create(null);
      this.printPreviewDialog = true;
    },
    errorIndexesHandler(i) {
      const idx = this.errorIndexes?.indexOf(i);
      if (idx !== -1) {
        this.errorIndexes?.splice(idx, 1);
      }
    },
    fetchUserCredit() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .post(app.$apipoint + "config/customer-club/dobare/current-credit", {
          user_id: this.idUser,
        })
        .then((r) => {
          this.userCredit = r.data.data.customer_club_credit;
          app.isLoading = false;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    getPosInfo() {
      const posDeviceArray = JSON.parse(localStorage.getItem("posDevice"));
      if (posDeviceArray != undefined && posDeviceArray.length > 0) {
        const activePos = posDeviceArray.find((obj) => obj.status == "active");
        if (
          activePos != undefined &&
          activePos.posIp != null &&
          activePos.posPort != null
        ) {
          const socket = new WebSocket("ws://127.0.0.1:8145/Query");
          socket.onopen = () => {
            socket.send(JSON.stringify({ Key: "POS" }));
          };
          socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            this.POSIP = data.Result.posIp;
            this.POSPORT = data.Result.posPort;
          };
        }
      }
    },
    getSocketVersion() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Query");
      socket.onopen = () => {
        socket.send(JSON.stringify({ Key: "DRIVER_VERSION" }));
      };
    },
    totalAmount(value) {
      this.totalPayment = value;
    },
    invoiceRemain(value) {
      this.remainInvoice = value;
    },
    selectTaxOption(item) {
      this.selectedTaxOption = item.value;
      if (item.value == "active") {
        this.taxStatus = "active";
      } else {
        this.taxStatus = "deactive";
      }
    },
    getPosesListBySocket() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Query");
      socket.onopen = () => {
        socket.send(JSON.stringify({ Key: "POSES" }));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.posesList = data.Result;
      };
    },
    openPosDialog(type, selectedItem) {
      this.addNewPosDialog = true;
      this.getPosesListBySocket();
      if (type == "add") {
        this.dialogType = "add";
        /* if (this.posItems.length > 0) { */
        this.clearPosForm();
        /* }  */
      }
      if (type == "edit" && selectedItem != null) {
        this.dialogType = "edit";
        this.newPos = {
          title: selectedItem.title,
          posDevice: selectedItem.posDevice,
          posIp: selectedItem.posIp,
          posPort: selectedItem.posPort,
          bank: selectedItem.bank,
          status: selectedItem.status,
        };
        this.selectedIndex = this.posItems.findIndex(
          (item) =>
            item.title == selectedItem.title &&
            item.posIp == selectedItem.posIp &&
            item.posPort == selectedItem.posPort
        );
      }
    },
    checkValidation() {
      if (this.$refs.posForm.validate() && this.dialogType == "add") {
        this.addPosRecord();
      }
      if (this.$refs.posForm.validate() && this.dialogType == "edit") {
        this.editPosRecord();
      }
    },
    addPosRecord() {
      this.posItems.push(this.newPos);
      this.posItems.forEach((item, index) => {
        item.status = index === 0 ? "active" : "deactive";
      });
      this.isPosActive = this.posItems[0].status === "active";
      this.addNewPosDialog = false;
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
    },
    editPosRecord() {
      this.posItems.splice(this.selectedIndex, 1, this.newPos);
      this.addNewPosDialog = false;
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
    },
    clearPosForm() {
      this.newPos = {
        title: null,
        posDevice: null,
        posIp: null,
        posPort: null,
        bank: null,
        status: null,
      };
      // reset form
      if (this.$refs.posForm) {
        this.$refs.posForm.reset();
      }
    },
    setActiveStatus(selectedIndex) {
      this.posItems.forEach((item, index) => {
        item.status = index === selectedIndex ? "active" : "deactive";
      });
      this.isPosActive = this.posItems[0].status === "active";
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
    },
    openDeletePermissionDialog(type, item, index) {
      this.deletePermissionDialog = true;
      if (type == "all") {
        this.isAllItemsDelete = true;
      }
      if (type == "single") {
        this.deletedIndex = index;
      }
    },
    removePosRecord() {
      if (this.isAllItemsDelete) {
        this.posItems = [];
      } else {
        this.posItems.splice(this.deletedIndex, 1);
      }
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
      this.deletePermissionDialog = false;
    },
    openOptionsDialog(value) {
      this.optionDialogType = value;
    },
    onTableUpdate(value) {
      this.compositeTableData = value;
    },
    getPrinterListBySocket() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Query");

      socket.onopen = () => {
        socket.send(JSON.stringify({ Key: "PRINTERQUERY" }));
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);

        this.printerList = data.Result;

        // socket.close()
      };
    },
    /* handleBarcodeScannerInput (event) {
        const currentTime = new Date().getTime()
        const timeSinceLastKeypress = currentTime - this.lastKeypressTime
        this.lastKeypressTime = currentTime
        if (timeSinceLastKeypress < this.barcodeInputThreshold) {
          if (event.key === 'Enter') {
            this.barcodeQueue.push(this.barcode)
            this.barcode = ''
            if (!this.processingBarcode) {
              this.processBarcodes()
            }
          } else {
            this.barcode += event.key
          }
        } else {
          this.barcode = event.key
        }
      }, */
    handleBarcodeScannerInput(event) {
      const currentTime = new Date().getTime();
      const timeSinceLastKeypress = currentTime - this.lastKeypressTime;
      this.lastKeypressTime = currentTime;
      if (timeSinceLastKeypress < this.barcodeInputThreshold) {
        if (event.key === "Enter") {
          const cleanedBarcode = this.barcode.replace(/Shift/g, "");
          this.barcodeQueue.push(cleanedBarcode);
          this.barcode = "";
          if (!this.processingBarcode) {
            this.processBarcodes();
          }
        } else {
          this.barcode += event.key;
        }
      } else {
        this.barcode = event.key;
      }
    },
    processBarcodes() {
      if (this.barcodeQueue.length > 0) {
        this.processingBarcode = true;
        const barcodeToProcess = this.barcodeQueue.shift();
        this.$refs.productCategoryRef.setSearchFocus();
        this.$refs.productCategoryRef.searchBarcode = barcodeToProcess;
        this.$refs.productCategoryRef.searchIntegrator();
        setTimeout(() => {
          this.processBarcodes();
        }, 300);
      } else {
        this.processingBarcode = false;
      }
    },
    goToInvoice(type) {
      this.visitType = type;
      this.askPermissionDialog = true;
      this.errorIndexes = null;
    },
    prevInvoice() {
      this.askPermissionDialog = false;
      this.show(this.currentId, "prev");
    },
    nextInvoice() {
      this.askPermissionDialog = false;
      this.show(this.currentId, "next");
    },
    otherProduct() {
      var app = this;
      const availbleRoute = [
        "invoiceCasher",
        "returnSellCasher",
        "invoiceCasherEdit",
      ].includes(this.$route.name);
      if (!availbleRoute) return;
      var name = (app.$t("otherProduct") + " " + app.otherProductCounter).toString();
      var isDB = localStorage.getItem("dbCreated");
      if (isDB && isDB === "active") {
        var connection = new window.JsStore.Connection();
        connection.openDb("db_" + this.$store.state.userId);
        connection
          .select({
            from: "products",
            where: {
              name: name,
            },
          })
          .then(function (data) {
            if (data && data.length > 0) {
              data[0].price = 0;
              app.append(data[0], "openEdit");
              app.otherProductCounter++;
            } else {
              app.$axios
                .get(app.$endpoint + "getdetail", {
                  params: {
                    select: "getOtherProduct",
                    name: name,
                  },
                })
                .then((res) => {
                  res = res.data;
                  res.price = 0;
                  app.append(res, "openEdit");
                  connection.insert({ into: "products", upsert: true, values: [res] });
                  app.otherProductCounter++;
                })
                .catch((err) => {
                  app.serverErrorHandeler(err);
                })
                .finally(
                  () =>
                    function () {
                      app.isLoading = false;
                      app.loading = false;
                    }
                );
            }
          });
      }
    },
    setRefBody(val) {
      this.itemsTableBodyHeight = val;
    },
    openNumpad(item) {
      this.selectedItemNumpad = item;
      this.numpadValue = item.count;
      this.numpadDialog = true;
    },
    setNumpad(data) {
      this.numpadDialog = false;
      this.selectedItemNumpad.count = data;
    },
    addProductFromDialog(data) {
      this.append(data);
      this.addProductDialog = false;
      var isDB = localStorage.getItem("dbCreated");
      if (isDB) {
        this.DBCreate();
      }
      if (isDB && isDB === "active") {
        var connection = new window.JsStore.Connection();
        connection.openDb("db_" + this.$store.state.userId);
        connection.insert({ into: "products", upsert: true, values: [data] });
      }
      // this.getAllProductsOffline('product')
    },
    downloadTools() {
      window.open("https://abriron.com/abrironapp/abriron-tools-windows.rar", "_blank");
      this.helpDialog = false;
    },
    clearAllItems() {
      if (this.askPermissionDialog) {
        this.askPermissionDialog = false;
      }
      this.items = [];
      this.calcSum();
      this.total = 0;
      this.totalTax = 0;
      this.discount = 0;
      this.totalCount = 0;
      this.totalPayment = 0;
    },
    searchIntegrator() {
      var isDB = localStorage.getItem("dbCreated");
      if (isDB && isDB === "active") {
        var app = this;
        var connection = new window.JsStore.Connection();
        connection.openDb("db_" + this.$store.state.userId);
        connection
          .select({
            from: "products",
            join: {
              with: "productIntegrator",
              on: "products.id=productIntegrator.product_id",
              type: "inner",
              where: {
                value: {
                  like: "%" + (app.searchBarcode ? app.searchBarcode : "") + "%",
                },
              },
            },
            groupBy: "product_id",
          })
          .then(function (data) {});
      }
    },
    printWithTools() {
      var local = localStorage.getItem("token");
      this.abrName = this.$store.state.abrName;
      var data = {
        userId: JSON.parse(local).init.userId + "000",
        body: this.$data,
      };
      this.$socket.emit("setValue", JSON.stringify(data));
    },
    setFocus() {
      if (this.$refs.productCategoryRef) {
        // this.$refs.productCategoryRef.setSearchFocus()
      }
      // this.$refs.searchRef.focus()
    },
    fullScreenFunc() {
      this.fullscreen = !this.fullscreen;
      if (this.fullscreen) {
        document.getElementById("app").requestFullscreen();
        console.log(document.getElementById("app"));
      } else {
        // document.getElementById('app').exitFullscreen()
      }
    },
    async getWeightClipboard() {
      // var app = this
      // app.weightInterval = setInterval(async function () {
      //   if (document.hasFocus()) {
      //     var clip = await navigator.clipboard.readText()
      //     if (app.isJsonString(clip)) {
      //       clip = JSON.parse(clip)
      //       app.weight = clip.weight
      //     }
      //   }
      // }, 100)
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    getItemWeight(item) {
      var bc = new BroadcastChannel("test_channel");
      bc.postMessage("This is a test message.");
      item.count = parseFloat(this.weight);
    },
    async getWeight() {
      var app = this;
      const socket = new WebSocket("ws://localhost:4022/Scale");
      socket.onopen = function (event) {
        socket.send("connect");
        socket.send("getweight");
      };
      socket.onmessage = function (event) {
        if (
          event.data !== "Error in getting weight" &&
          event.data !== "Thread Started" &&
          event.data !== "Not Connected" &&
          event.data !== "True"
        ) {
          var weight = event.data.split("/");
          if (weight.length > 1) {
            app.weight = weight[0] + "." + weight[1];
          } else {
            app.weight = weight[0];
          }
        }
      };
    },
    stopWeight() {
      const socket = new WebSocket("ws://localhost:4022/Scale");
      socket.onopen = function (event) {
        // socket.send('connect')
        socket.send("stopweight");
      };
      socket.onmessage = function (event) {};
    },
    addCount(item) {
      item.count++;
      var app = this;
      clearTimeout(this.appendTimer);
      this.appendTimer = setTimeout(function () {
        app.calcSum();
      }, 100);
    },
    minusCount(item) {
      item.count--;
      var app = this;
      clearTimeout(this.appendTimer);
      this.appendTimer = setTimeout(function () {
        app.calcSum();
      }, 100);
    },
    goToReturnSell() {
      // this.$root.$emit('createReturnSell')
      this.$router.push({
        name: "returnSellCasher",
        params: { accountProp: this.account, sellLinkProp: true },
      });
    },
    goToSell() {
      if (!this.$refs.form.validate()) return false;
      var data = {
        total: this.total,
      };
      this.$router.push({ name: "invoiceCasher", params: { returnSellProp: data } });
    },
    setOffline(val) {
      this.offline = val;
    },
    unitCalc(item) {
      if (item.product && item.unit) {
        var i = item.product.units.findIndex((x) => x.unit_id === item.unit.id);
        if (i !== -1 && item.product.units[i].value) {
          return +item.product.units[i].value;
        } else {
          return 1;
        }
      }
    },
    unitItems(item) {
      if (item.product) {
        var units = [item.product.unit];
        if (item.product.units) {
          item.product.units.map(function (value, index) {
            value.unit.value = value.value;
            units.push(value.unit);
          });
        }
        if (!item.unit) {
          item.unit = item.product.unit;
        }
        return units;
      } else {
        return [];
      }
    },
    onResize() {
      var height = 350;
      if (!this.isMobile && window.innerHeight < 750) {
        height = 507;
      }
      if (this.isMobile) {
        height = 440 + (this.returnSellProp ? 70 : 0);
      }
      if (this.isMobile && window.innerHeight < 900 && window.innerHeight > 750) {
        height = 460 + (this.returnSellProp ? 70 : 0);
      }
      if (this.isMobile && window.innerHeight < 750) {
        height = 480 + (this.returnSellProp ? 70 : 0);
      }
      this.tableHeightInvoice = window.outerHeight - height;
      this.$store.commit("SET_TABLEHEIGHTINVOICE", this.tableHeightInvoice);
    },
    beforeMount() {
      this.bottomNavigation = true;
      if (this.accountProp) {
        this.account = this.accountProp;
      }
      if (this.$route.params.id != null) {
        this.id = this.$route.params.id;
        this.uid = this.$route.params.id;
        this.show();
        this.render = false;
      } else {
        this.defaultCurrency = this.getDefault("defaultCurrency");
        this.currency = this.$store.state.currency;
        if (this.offline && !this.callInvoiceByNumber) {
          this.getInvoiceNumberOffline();
        } else {
          this.getInvoiceNumber();
        }
        if (this.items && this.items.length === 0) {
          // this.addRow()
        }
      }
      if (this.$store.state.currency && !this.id && !this.account) {
        this.currency = this.$store.state.currency;
        this.currency_amount = this.$store.state.currency.amount;
      }
      if (this.itemsProp) {
        this.items = this.itemsProp;
      } else {
        if (!this.isMobile && !this.account && !this.id) {
          /* this.items = [] */
          // this.addRow()
        }
      }
      var isDB = localStorage.getItem("dbCreated");
      if (!isDB) {
        this.DBCreate();
      }
    },
    checkProductsCount() {
      var app = this;
      if (this.items && this.items.length > 0) {
        this.items.map(function (value, index) {
          // value.product = null
          if (app.$refs["refProduct" + index] !== undefined) {
            // app.$refs['refProduct' + index].clear()
          }
        });
      }
    },
    zeroCountCheck(item) {
      if (parseFloat(item.count) === 0) {
        item.count = 1;
        this.checkCount(item);
      }
    },
    discountChangeStatus() {
      this.percentDiscountStatus = !this.percentDiscountStatus;
      this.taxStatus = false;
    },
    discountCheck() {
      this.discount = 0;
      this.totalDiscount = 0;
      if (Number(this.discountPercent) > 100) {
        this.discountPercent = 100;
      }
      if (Number(this.discountPercent) < 0) {
        this.discountPercent = 0;
      }
      if (this.total > 0) {
        var discount = this.total * (this.discountPercent / 100);
        this.discount = discount.toFixed(this.decimal);
        this.checkTotalDiscount();
      }
    },
    checkBankRemain(sum) {
      var app = this;
      app.validBank = true;
      if (app.type === "purchase" || app.type === "returnSell") {
        if (
          this.clearingStatus &&
          this.bank &&
          sum > parseFloat(this.bank.remain.currency_remain)
        ) {
          app.validBank = true;
          app.snakbarText = this.$t("alert-pay-amount-bigger-than-bank-remain");
          app.snakbarColor = "pink";
          app.snakbar = true;
        }
      }
    },
    getInvoiceNumber() {
      if (this.type === "returnPurchase" || this.type === "purchase") {
        return false;
      }
      this.loading = true;
      var app = this;
      app.isLoading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              type: app.type,
              id: app.id,
              number: app.number,
              callInvoice: app.callInvoiceByNumber,
              select: "getInvoiceNumber",
            },
          })
          .then((res) => {
            res = res.data;
            if (res.status === "error") {
              if (app.checkNumber && !app.callInvoiceByNumber) {
                app.snakbarText = res.message;
                app.snakbarColor = "pink";
                app.snakbar = true;
              }
              app.number = res.number;
              if (app.callInvoiceByNumber && res.invoice) {
                app.id = res.invoice.uid;
                app.show();
                // app.$router.push({ name: 'invoiceCasherEdit', params: { id: res.invoice.uid, tabName: res.invoice.number } })
              } else {
                app.number = res.number;
              }
            }
            app.number = res.number;
            app.checkNumber = true;
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(function () {
            app.loading = false;
            app.isLoading = false;
          });
      }, 50);
    },
    callInvoiceById(e) {
      if (!this.numberForEdit) {
        return false;
      }
      this.loading = true;
      var app = this;
      app.isLoading = true;
      this.clearForm();
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              number: app.numberForEdit,
              select: "getInvoiceUidById",
            },
          })
          .then((res) => {
            res = res.data;
            if (res.uid) {
              app.id = res.uid;
              app.show();
            }
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(function () {
            app.loading = false;
            app.isLoading = false;
          });
      }, 50);
    },
    getOfficialInvoiceNumber() {
      if (this.type === "returnPurchase" || this.type === "purchase") {
        return false;
      }
      this.loading = true;
      var app = this;
      app.isLoading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              type: app.type,
              id: app.id,
              number: app.officialNumber,
              select: "getOfficialInvoiceNumber",
            },
          })
          .then((res) => {
            res = res.data;
            if (res.status === "error") {
              if (app.checkOfficialNumber) {
                app.snakbarText = res.message;
                app.snakbarColor = "pink";
                app.snakbar = true;
              }
              app.officialNumber = res.number;
            }
            app.checkOfficialNumber = true;
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }, 50);
      // setTimeout(() => {
      //   app.$refs.autocomplete.onScroll()
      // }, 1500)
      this.loading = false;
    },
    changeProduct(item) {
      if (
        this.type === "sell" ||
        this.type === "returnPurchase" ||
        this.type === "presale"
      ) {
        if (
          this.currency &&
          item.product &&
          item.product.price &&
          this.currency.id === this.$store.state.currency.id
        ) {
          item.fee = item.product.price;
        } else {
          if (!this.id && !this.itemsProp) {
            // item.fee = 0
          }
        }
      }
    },
    clearRow(item) {
      item.fee = 0;
      item.count = 0;
      item.discount = 0;
      item.discountPercent = 0;
      item.tax = 0;
    },
    clearRows() {
      this.items.map(function (value, index) {
        value.fee = 0;
        value.count = 0;
        value.discount = 0;
        value.discountPercent = 0;
        value.tax = 0;
      });
    },
    changePercent(val) {
      this.discountPercent = val;
      this.percentDiscountStatus = true;
    },
    append(product, call = null) {
      this.offline = false;
      var app = this;
      var count = product.count ? product.count : 1;
      var stock = 20000000;
      if (!this.offline && product.type === "product") {
        stock = product.stock ? product.stock.count : 2000000;
        if (this.type === "sell" || this.type === "returnPurchase") {
          if (this.offline && (!product.stock || product.stock.count <= 0)) {
            this.snakbarText = this.$t("alert-is-not-enough-inventory");
            this.snakbarColor = "pink";
            this.snakbar = true;
            return false;
          }
          if (product.stock && product.stock.count < 1) {
            // count = parseFloat(product.stock.count)
          }
        }
      }
      var index = -1;
      // if (this.items && this.items.length == 0) {
      //   this.addRow()
      // }
      if (this.items && this.items.length > 0 && !this.items[0].product) {
        this.items.splice(0, 1);
      }
      index = this.items.findIndex((x) =>
        x.product ? x.product.id === product.id : null
      );
      if (index !== -1) {
        if (
          parseFloat(stock) - parseFloat(this.items[index].count) - parseFloat(count) >=
          0
        ) {
        }
        this.items[index].count = parseFloat(this.items[index].count) + parseFloat(count);
        if (this.type === "sell" || this.type === "presale") {
          if (product && !product.price) {
            this.getPrice(this.items[index]);
          }
        }
      } else {
        if (
          this.scale &&
          this.scale === "active" &&
          product.unit &&
          product.unit.type === "jointed"
        ) {
          if (product.unit.name === "Kg") {
            count = parseFloat(this.weight);
          } else {
            count = parseFloat(this.weight * 1000);
          }
        }
        var price = product.price ? product.price : 0;
        this.addRow(product, count, price);
      }
      clearTimeout(this.appendTimer);
      if (call === "openEdit") {
        setTimeout(function () {
          app.$refs.refInvoiceItems.openProductEdit(app.items[app.items.length - 1]);
        }, 100);
      }
      // this.$refs.refInvoiceItems.scrollToBottom(this)
      this.scrollToBottom(this);
      this.appendTimer = setTimeout(function () {
        app.calcSum();
      }, 250);
    },
    scrollToBottom(app) {
      setTimeout(function () {
        app.$refs.refScroll.scrollTop = app.itemsTableBodyHeight;
      }, 50);
    },
    getPrice(item) {
      var app = this;
      clearTimeout(this.timer);
      if (!this.showProductList) {
        app.isLoading = true;
      }
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              select: "getPrice",
              currency_id: app.currency.id,
              count: item.count,
              product_id: item.product.id,
              category_id:
                app.account && app.account.category_id ? app.account.category_id : -1,
            },
          })
          .then((res) => {
            res = res.data;
            if (res.price > 0) {
              item.fee = res.price;
            } else {
              item.fee = 0;
            }
            if (item.fee > 0 && item.count > 0) {
              if (res.discount.amount) {
                item.discount = res.discount.amount;
              }
              if (res.discount.percent && parseFloat(res.discount.percent) > 0) {
                var discount =
                  parseFloat(item.fee) *
                  parseFloat(item.count) *
                  (parseFloat(res.discount.percent) / 100);
                item.discount = discount;
              }
            }
            app.calcSum();
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }, 500);
      this.loading = false;
    },
    calcSum() {
      var app = this;
      app.totalTax = 0;
      app.totalDiscount = this.discountEdit ? this.discountEdit : 0;
      app.totalCount = 0;
      app.totalFee = 0;
      app.sum = 0;
      var sumDiscount = 0;
      // if (!this.discountPercent) {
      //   this.discount = 0
      // }
      this.items.map(function (value, index) {
        if (value.discountPercent > 0) {
          value.discount =
            parseFloat(value.fee * value.count) * (value.discountPercent / 100);
        }
        if (
          parseFloat(value.count) * parseFloat(value.fee) <
          parseFloat(value.discount)
        ) {
          value.discount = 0;
          app.discount = 0;
          app.totalDiscount = 0;
        }
        if (app.totalDiscountType) {
          value.discount = 0;
          value.tax = 0;
        } else {
          sumDiscount = sumDiscount + parseFloat(value.discount);
          app.calcTax(value);
        }
        app.totalFee =
          parseFloat(value.count) * parseFloat(value.fee) + parseFloat(app.totalFee);
        app.totalCount = parseFloat(value.count) + parseFloat(app.totalCount);
        app.totalTax = parseFloat(value.tax) + parseFloat(app.totalTax);
        var rowPrice =
          parseFloat(value.fee * value.count) -
          parseFloat(value.discount === "" || !value.discount ? 0 : value.discount) +
          parseFloat(isNaN(value.tax) ? 0 : value.tax);
        app.sum = parseFloat(rowPrice) + parseFloat(app.sum);
      });
      app.totalFee = app.totalFee.toFixed(this.decimal);
      app.totalTax = app.totalTax.toFixed(this.decimal);
      if (sumDiscount > 0) {
        app.discount = sumDiscount;
        // app.totalDiscount = sumDiscount
      }
      this.discountEdit = 0;
    },
    checkTotalDiscount() {
      this.taxStatus = false;
      this.totalDiscountType = true;
      this.calcSum();
      // if (this.discountPercent) {
      //   if (parseFloat(this.discount) > 100) {
      //     this.discount = 0
      //   }
      //   var discount = parseFloat(this.sum) * (parseFloat(this.discount) / 100)
      //   this.totalDiscount = discount
      // } else {
      this.totalDiscount = this.discount;
      // }
      if (
        this.discountPercent === false &&
        parseFloat(this.discount) > parseFloat(this.sum)
      ) {
        this.discount = 0;
        this.totalDiscount = 0;
      }
    },
    calcTax(item) {
      if (this.taxStatus === "active") {
        var tax =
          ((parseFloat(item.fee * item.count) -
            parseFloat(item.discount === "" || !item.discount ? 0 : item.discount)) *
            item.taxPercent) /
          100;
        item.tax = tax.toFixed(this.$store.state.currency.decimal);
      } else {
        item.tax = 0;
      }
    },
    changeCurrency() {
      this.bankRemain = 0;
      this.currency_amount = this.currency.amount;
      this.options = {
        locale: "en-US",
        prefix: "",
        suffix: this.currency.name,
        precision: 0,
      };
    },
    addRow(product = null, count = 0, price = 0) {
      this.items.push({
        product: product,
        count: count,
        countEdit: 0,
        fee: price,
        discount: 0,
        discountPercent:
          product && product.discount_percent > 0 ? product.discount_percent : 0,
        tax: 0,
        taxPercent: product && product.tax_percent > 0 ? product.tax_percent : 0,
        unit: null,
        content: 0,
      });
      if (this.type === "sell" && product && !product.price) {
        var index = this.items.findIndex((x) => x.product.id === product.id);
        this.getPrice(this.items[index]);
      }
    },
    remove(item) {
      var i = this.items.indexOf(item);
      this.items.splice(i, 1);
      this.deleteItem = null;
      this.calcSum();
      this.deletDialog = false;
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: "ProductEdit", params: { id: item.id } });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "products", {
          params: {
            search: app.search,
            page: app.tableOptions.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            // typeForm: app.typeForm,
          },
        })
        .then((res) => {
          res = res.data;
          app.items = res.data;
          app.totalItems = res.total;
          app.from = res.from;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    checkProduct(item, key) {
      if (item) {
        var index = this.items.findIndex((x) => x.product.id === item.id);
        if (index !== key) {
          this.$refs["refProduct" + key].clear();
          this.snakbarText = this.$t("alert-product-is-repetitive");
          this.snakbarColor = "pink";
          this.snakbar = true;
        }
      }
    },
    checkDiscount(item) {
      this.totalDiscountType = false;
      this.totalDiscount = 0;
      this.discount = 0;
      if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
        item.discount = 0;
      }
      item.discountPercent = this.itemDiscountPercentCalc(item);
      this.calcSum();
    },
    checkDiscountPercent(item) {
      this.totalDiscountType = false;
      this.totalDiscount = 0;
      this.discount = 0;
      item.discount = (
        parseFloat(item.fee * item.count) *
        (item.discountPercent / 100)
      ).toFixed(this.decimal);
      if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
        item.discount = 0;
        item.discountPercent = 0;
      }
      this.calcSum();
    },
    itemDiscountPercentCalc(item) {
      return (parseFloat(item.discount) / parseFloat(item.fee * item.count)) * 100;
    },
    checkCount(item) {
      if (
        !this.offline &&
        (this.type === "sell" ||
          this.type === "presale" ||
          this.type === "returnPurchase")
      ) {
        var productStock =
          item.product && item.product.stock ? parseFloat(item.product.stock.count) : 0;
        if (
          item.product &&
          item.product.type === "product" &&
          this.$store.state.negative_inventory === "no" &&
          parseFloat(item.count) >
            productStock +
              parseFloat(this.$route.name !== "presaleEdit" ? item.countEdit : 0)
        ) {
          this.snakbarText = this.$t("alert-inventory-is-not-enough");
          this.snakbarColor = "pink";
          this.snakbar = true;
          // item.count = 0
        } else {
          if (this.$route.name !== "presaleEdit" && item.product && !item.product.price) {
            if (this.type === "sell" || this.type === "presale") {
              this.getPrice(item);
            }
          }
        }
      }
      this.calcSum();
    },
    removegroup() {
      var app = this;
      app.selected.map(function (value, key) {
        app.remove(value, key);
      });
    },
    createOffline() {
      if (!this.$refs.form.validate()) return false;
      var app = this;
      var token = JSON.parse(localStorage.getItem("token"));
      var list = JSON.parse(localStorage.getItem("invoice"));
      if (!list) {
        list = [];
      }
      this.ouid = token.init.userId + "@" + Date.now() + "@" + this.number;
      list.push(this.$data);
      localStorage.setItem("invoice", JSON.stringify(list));
      localStorage.setItem("invoiceNumber", this.number);
      if (!this.$store.state.offlineInvoiceTrigger) {
        this.createInvoiceOffline();
      }
      this.$store.commit("SET_OFFLINEINVOICETRIGGER", true);
      if (app.autoPrint && app.redirectUrl) {
        if (app.type === "sell" || app.type === "presale") {
          if (app.printType === "normal") {
            app.$router.push({
              name: "invoicePrint",
              params: { id: this.ouid, offlineProp: true },
            });
          } else {
            var numberPrintForNewInvoice =
              this.type === "sell" &&
              !this.id &&
              this.$store.state &&
              this.$store.state.allConfig &&
              this.$store.state.allConfig.printNumberForNewInvoice === "active"
                ? true
                : null;
            app.$router.push({
              name: "invoiceRollprint",
              params: {
                id: this.ouid,
                backUrl: "invoiceCasher",
                offlineProp: true,
                abrironPrinterProp: app.abrironPrinter,
                numberPrint: numberPrintForNewInvoice,
              },
            });
          }
        } else {
          app.goTo(app.type + "List");
        }
      }
      app.items = [];
      app.account = null;
      if (app.type === "sell" && app.returnSellProp) {
        // app.$root.$emit('createReturnSell')
      }
      app.redirectUrl = true;
    },
    createInvoiceHeader(type = null) {
      var app = this;
      var checkVisitor = false;
      if (!this.account) {
        this.pattern = 2;
      }
      if (!this.$refs.form.validate()) return false;
      if (
        this.type === "sell" &&
        this.$store.state.allConfig &&
        this.$store.state.allConfig.userInt &&
        this.$store.state.allConfig.userInt.visitor === "active"
      ) {
        checkVisitor = true;
      }
      if (this.items.length === 0) {
        app.snakbarText = app.$t("noItems");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }
      if (!this.account) {
        app.snakbarText = app.$t("noAccount");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }
      if (this.offline && !checkVisitor) {
        // this.createOffline()
        // this.clearForm()
        // return false
      }
      app.createIdInvoice = "active";
      app.snakbar = false;
      app.isLoading = true;
      app.$axios
        .post(this.$endpoint + "invoice", this.$data)
        .then((res) => {
          res = res.data;
          app.idPrint = res.id;
          app.id = res.id;
          app.uid = res.uid;
          app.redirectUrl = true;
          app.printStatus = type;
          setTimeout(function () {
            if (type === "printId" || type === "print") {
              app.print();
            }
            // app.clearForm()
          }, 100);
          app.update();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.nextPermission = false;
          this.redirectUrl = true;
          this.isLoading = false;
        });
    },
    resolvePrintType(type) {
      if (type == "posProcess") {
        return "print";
      } else {
        return type;
      }
    },
    create(type = null, e) {
      if (e?.preventDefault) e.preventDefault();
      if (this.isLoading) return;
      var app = this;
      var checkVisitor = false;
      if (!this.account) {
        this.pattern = 2;
      }
      /* if (this.$refs.form.validate()) { */
      /* if (!this.$refs.form.validate()) return false */
      // this.items.map(function (value, index) {
      //   if (!value.product) {
      //     this.remove(value, index)
      //   }
      // })
      if (
        this.type === "sell" &&
        this.$store.state.allConfig &&
        this.$store.state.allConfig.userInt &&
        this.$store.state.allConfig.userInt.visitor === "active"
      ) {
        checkVisitor = true;
      }
      if (this.items.length === 0) {
        app.snakbarText = app.$t("noItems");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }
      if (!this.account) {
        app.snakbarText = app.$t("noAccount");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }

      app.snakbar = false;
      app.isLoading = true;

      app.$axios
        .post(this.$endpoint + "invoice", this.$data)
        .then((res) => {
          if (res) {
            res = res?.data;
            app.nextPermission = true;
            if (res.status === "success") {
              app.invoiceSubmited = true;
              app.snakbarText = this.$t("registered");
              app.snakbarColor = "green";
              app.snakbar = true;
              if (checkVisitor) {
                app.account = null;
              }
              app.idPrint = res.data.id;
              app.redirectUrl = true;
              app.printStatus = this.resolvePrintType(type);
              app.lastId = res.data.id;
              app.currentId = res.data.id;
              app.number = res.data.number;
              app.uidLastInv = res.data.uid;

              if (type === "printId" || type === "print") {
                app.print("create");
              } else {
                setTimeout(function () {
                  if (type != "posProcess") {
                    app.clearForm();
                  }
                }, 200);
              }
              if (type == "posProcess") {
                this.startPosProsess();
              }
            } else {
              app.snakbarText = this.$t("error");
              app.snakbarColor = "green";
              app.snakbar = true;
            }
          }
        })
        .catch((err) => {
          this.isLoading = false;
          if (err && err.response) {
            this.serverErrorHandeler(err);
            // out-of-stock product
            if (
              err.response.data.status == 500 &&
              err.response.data.errorItems &&
              err.response.data.errorItems.length > 0
            ) {
              const outOfStockIndexes = err.response.data.errorItems.map(
                (item) => item.index
              );
              this.errorIndexes = outOfStockIndexes;

              this.snakbarText = app.$t("there is no enough products for this entrepots");
              this.snakbarColor = "pink";
              this.snakbar = true;
            } else {
              // amount (fee)
              const errors = err.response.data.errors;
              const indexErrors = [];
              Object.keys(errors).forEach((key) => {
                indexErrors.push(parseInt(key.split(".")[1]));
              });
              this.errorIndexes = indexErrors;
            }
          }
        })
        .finally(() => {
          this.nextPermission = false;
          this.redirectUrl = true;
          // this.isLoading = false
        });
      /* } else {
          console.log('test 6')
          const refs = ['number', 'refAccount', 'date', 'refCurrency']
          const invalidFields = []

          refs.forEach(ref => {
            const field = this.$refs[ref]

            if (!field) {
              return
            }

            const value = field.internalValue ?? field.value ?? field.$el?.value

            // Check if field is empty
            if (!value) {
              invalidFields.push(field.label || field.title || ref)
            }

            // If validate method exists, use it as well
            if (typeof field.validate === 'function' && !field.validate()) {
              const label = field.label || field.title || field.$attrs?.label || ref
              if (!invalidFields.includes(label)) invalidFields.push(label)
            }
          })

          if (invalidFields.length) {
            this.snakbarText = this.$t('pleaseCheckFields') + ': ' + invalidFields.join(', ')
            this.snakbarColor = 'pink'
            this.snakbar = true
          }
        } */
    },
    update(type = null) {
      var app = this;
      if (this.items.length === 0) {
        app.snakbarText = app.$t("noItems");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }
      app.snakbar = false;
      app.isLoading = true;
      /* if (type === 'printId' || type === 'print') {
          app.print()
        } */
      app.$axios
        .put(this.$endpoint + "invoice/" + this.uid, this.$data)
        .then((res) => {
          res = res.data;
          app.number = res.data.number;

          if (type === "printId" || type === "print") {
            app.print("update");
          } else {
            setTimeout(function () {
              app.clearableForm();
            }, 200);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          if (err && err.response) {
            this.serverErrorHandeler(err);
            // out-of-stock product
            if (
              err.response.data.status == 500 &&
              err.response.data.errorItems &&
              err.response.data.errorItems.length > 0
            ) {
              const outOfStockIndexes = err.response.data.errorItems.map(
                (item) => item.index
              );
              this.errorIndexes = outOfStockIndexes;
            } else {
              // stock
              const errors = err.response.data.errors;
              const indexErrors = [];
              Object.keys(errors).forEach((key) => {
                indexErrors.push(parseInt(key.split(".")[1]));
              });
              this.errorIndexes = indexErrors;
            }
          }
        })
        .finally(() => {
          this.nextPermission = false;
          // this.isLoading = false
        });
    },
    show(currentId = null, order = null) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice/" + this.id + "/edit", {
          params: {
            id: this.id,
            currentId: currentId,
            order: order,
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            if (res.data !== "") {
              res = res.data;
              app.id = res.id;
              if (!app.lastId) {
                app.lastId = res.id;
              }
              app.currentId = res.id;
              app.uid = res.uid;
              app.currency = res.currency;
              app.decimal = res.currency ? res.currency.decimal : 0;
              app.currency_amount = res.currency_amount;
              app.number = res.number;
              app.officialNumber = res.official_number;
              app.content = res.content;
              app.date = res.date;
              app.given = res.given;
              app.type = res.type;
              app.items = res.article;
              app.account = res.customer;
              app.entrepot = res.entrepot ? res.entrepot.entrepot : null;
              app.dueDate = res.due_date;
              app.branch = res.branch ? res.branch : null;
              app.payments = res.payments;
              app.credit = res.credit;
              app.credit_status = res.creditStatus;
              app.prevCredit = res.credit;
              app.checks = res.checks;
              app.status = res.last_status ? res.last_status.status : null;
              app.discount = res.discount;
              app.plan = res.plan ? res.plan.plan : null;
              app.totalDiscount = res.discount;
              app.compositeTableData = res.compositeTableData;
              app.editCompositeTableData = [...res.compositeTableData];
              app.items.map(function (value, index) {
                if (value.discount && value.discount > 0) {
                  app.checkDiscountEdit = true;
                }
              });
              if (!app.checkDiscountEdit) {
                app.discountEdit = res.discount;
              }
              // app.totaltax = res.tax
              if (res.tax > 0) {
                app.taxStatus = "active";
                app.taxPercent = res.tax_percent;
              }
              if (res.tags) {
                app.tag = res.tags;
                app.more = true;
              }
              this.posErrorDialog = false;
              this.performingInv = false;
              this.posPending = false;
              setTimeout(function () {
                app.render = true;
              }, 1000);
              app.calcSum();
            }
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    setToday() {
      var m = moment();
      if (this.$store.state.date_locale === "fa,en") {
        const shamsiYear = m.jYear();
        const shamsiMonth = String(m.jMonth() + 1).padStart(2, "0");
        const shamsiDay = String(m.jDate()).padStart(2, "0");
        return `${shamsiYear}/${shamsiMonth}/${shamsiDay}`;
      }
      if (this.$store.state.date_locale === "en,fa") {
        return m.format("YYYY/MM/DD");
      }
    },
    getInvoiceNumberOffline() {
      if (this.type === "returnPurchase" || this.type === "purchase") {
        return false;
      }
      var number = JSON.parse(localStorage.getItem("invoiceNumber"));
      if (!number) {
        number = 1;
      } else {
        number = +number + 1;
      }
      this.number = number;
    },
    clearableForm() {
      this.id = null;
      this.account = null;
      this.numberForEdit = null;
      this.clearForm();
    },
    clearForm() {
      if (this.askPermissionDialog) {
        this.askPermissionDialog = false;
      }
      this.selected = [];
      this.render = true;
      this.otherProductCounter = 1;
      this.createIdInvoice = null;
      this.paymentByPos = null;
      this.cashAmount = null;
      this.paymentAmount = null;
      this.lodingText = null;
      this.loadingDialog = false;
      this.bodyStatus = false;
      this.printDialog = false;
      this.credit = null;
      this.credit_status = false;
      this.userCredit = null;
      this.deletDialog = false;
      this.errorIndexes = null;
      this.showClearing = true;
      this.showSelect = false;
      this.date = this.setToday();
      this.showProductList = false;
      // this.clearingStatus = false
      this.filter = false;
      this.valid = true;
      this.number = null;
      // this.bank = null
      this.given = null;
      // this.entrepot = null
      this.payments = null;
      this.uid = null;
      this.checks = null;
      this.officialNumber = null;
      // this.account = null
      this.dueDate = null;
      // this.date = null
      // this.currency_amount = null
      this.content = null;
      this.model = null;
      this.from = 1;
      this.taskDialog = null;
      this.id = null;
      this.status = null;
      this.tag = null;
      this.temp = null;
      this.deleteItem = null;
      this.sellStatus = null;
      this.items = [];
      this.dialog = null;
      this.timer = 0;
      this.isLoading = false;
      /* this.snakbar = false */
      this.taskId = null;
      /* this.snakbarText = null */
      this.loading = false;
      this.search = null;
      this.discountPercent = false;
      this.taxStatus = false;
      this.totalCount = 0;
      this.discount = 0;
      this.totalDiscount = 0;
      this.totalTax = 0;
      this.totalFee = 0;
      this.sumRow = 0;
      this.clearingStatus = false;
      this.sum = 0;
      /* this.branch = null */
      this.totalDiscountType = false;
      this.editCompositeTableData = [];
      this.compositeTableData = [];
      if (this.offline && !this.callInvoiceByNumber) {
        this.getInvoiceNumberOffline();
      } else {
        this.getInvoiceNumber();
      }
      if (!this.autoPrint) {
        this.account = null;
      }
      this.addRow();
      this.$refs.form.resetValidation();
    },
    openCalculator() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Utility");
      socket.onopen = () => {
        socket.send(JSON.stringify({ cmd: "0" }));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.IsSuccessful) {
          this.snakbar = true;
          this.snakbarText = this.$t("runing system calculator");
          this.snakbarColor = "green";
        }
        // socket.close()
      };
    },
    openWindowsKeyboard() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Utility");
      socket.onopen = () => {
        socket.send(JSON.stringify({ cmd: "1" }));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.IsSuccessful) {
          this.snakbar = true;
          this.snakbarText = this.$t("runing system keyboard");
          this.snakbarColor = "green";
        }
        // socket.close()
      };
    },
    sendToPosProcess(value) {
      if (value != undefined && value != null && value != "remain") {
        this.compositeAmount = value;
      }
      this.create("posProcess");
    },
    startPosProsess() {
      // check added pos device
      const posDeviceArray = JSON.parse(localStorage.getItem("posDevice"));
      if (
        (posDeviceArray != undefined && posDeviceArray.length == 0) ||
        posDeviceArray == undefined
      ) {
        this.snakbar = true;
        this.snakbarText = this.$t("first in setting below set your pos device.");
        this.snakbarColor = "red";
      }
      // start the process:
      if (posDeviceArray != undefined && posDeviceArray.length > 0) {
        //set PosIp
        this.setPosIp(posDeviceArray);
      }
    },
    setPosIp(value) {
      const selectedPos = value.find((item) => item.status == "active");
      var selectedPosKey;
      if (selectedPos.posDevice.Key == "EghtesadNovin") {
        selectedPosKey = 0;
      }
      if (selectedPos.posDevice.Key == "Saman") {
        selectedPosKey = 1;
      }
      if (selectedPos.posDevice.Key == "BehPardakht") {
        selectedPosKey = 2;
      }
      if (selectedPos.posDevice.Key == "Fanap") {
        selectedPosKey = 3;
      }
      if (selectedPos.posDevice.Key == "Parsian") {
        selectedPosKey = 4;
      }
      const socket = new WebSocket("ws://127.0.0.1:8145/Command");
      socket.onopen = () => {
        const message = {
          Key: 1,
          Data: {
            PosIP: this.POSIP == null ? this.newPos.posIp : this.POSIP,
            PosPort: this.POSPORT == null ? this.newPos.posPort : this.POSPORT,
            PosType: selectedPosKey,
          },
        };
        socket.send(JSON.stringify(message));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data == 0) {
          // success
          // initialize pos device
          this.sendToPos(selectedPosKey);
        } else {
          // failed
          this.isLoading = false;
          this.posErrorDialog = true;
          this.posErrorTxt = this.$t("POSIP did not set correctly.");
        }
      };
    },
    sendToPos(selectedPosKey) {
      const socket = new WebSocket("ws://127.0.0.1:8145/Pos");
      this.progressPercent = 0;
      this.isPosSuccessfull = false;
      this.posPending = true;
      this.loadingDialog = true;
      this.lodingText = this.$t("waitingTogetDataFromPOS");

      let interval = setInterval(() => {
        if (this.progressPercent < 100) {
          this.progressPercent += 1;
        } else {
          clearInterval(interval);
        }
      }, 300);

      let state = "init"; // or: 'waitingForResponse'

      const timeout = setTimeout(() => {
        if (!this.isPosSuccessfull && state === "waitingForResponse") {
          clearInterval(interval);
          this.loadingDialog = false;
          this.posPending = false;
          this.snakbar = true;
          this.snakbarText = data.ResponseMessage;
          this.snakbarColor = "red";
        }
      }, 35000);

      socket.onopen = () => {
        const message = {
          Cmd: 0,
          PosType: selectedPosKey,
        };
        socket.send(JSON.stringify(message));
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (state === "init" && data === 0) {
          // Initial response, send transaction
          const message = {
            Cmd: 1,
            PosType: selectedPosKey,
            Amount:
              this.compositeAmount != null
                ? Number(this.compositeAmount)
                : Number(this.remainInvoice),
          };
          socket.send(JSON.stringify(message));
          state = "waitingForResponse";
        } else if (state === "waitingForResponse") {
          if (data?.IsSuccessfull) {
            const posDeviceArray = JSON.parse(localStorage.getItem("posDevice"));
            if (posDeviceArray != undefined && posDeviceArray.length > 0) {
              this.selectedBank = posDeviceArray.find(
                (obj) => obj.status == "active"
              ).bank;
            }

            // Success
            this.snakbar = true;
            this.snakbarText = data.ResponseMessage;
            this.snakbarColor = "green";

            clearInterval(interval);

            clearTimeout(timeout);
            this.progressPercent = 100;
            this.isPosSuccessfull = true;

            this.returnPosInfo = {
              amount: data.Amount,
              date: data.Time,
            };

            this.optionDialogType = null;
            this.$nextTick(() => {
              this.optionDialogType = "pos";
            });

            setTimeout(() => {
              this.loadingDialog = false;
              this.posPending = false;
              // *** call recieve api
              this.submitRecieve();
            }, 4000);
          } else if (data?.IsSuccessfull === false) {
            // Canceled or failed early
            clearInterval(interval);
            clearTimeout(timeout);
            this.progressPercent = 0;
            this.isPosSuccessfull = false;
            this.loadingDialog = false;
            this.posPending = false;

            this.isLoading = false;
            this.posErrorDialog = true;
            this.posErrorTxt = data.ResponseMessage;

            if (data.ResponseMessage == "پاسخ تعریف نشده") {
              this.isLoading = false;
              this.posErrorDialog = true;
              this.posErrorTxt = this.$t(
                "connection to the socket has problem please try again."
              );
            }
          }
          if (this.compositeAmount != null) {
            this.compositeAmount = null;
          }
        } else {
          // Connection failed or unexpected message
          clearInterval(interval);
          clearTimeout(timeout);
          this.progressPercent = 0;

          this.isLoading = false;
          this.posErrorDialog = true;
          this.posErrorTxt = this.$t("connection to pos Device didn't create");

          this.loadingDialog = false;
        }
      };
    },
    print(type) {
      const socket = new WebSocket("ws://127.0.0.1:8145/Print");
      var app = this;
      socket.onopen = () => {
        var body = this.$refs.refPrint.innerHTML;
        console.log(body);
        var html =
          '<!DOCTYPE html><html><meta charset="utf-8"><head>' +
          "<style scoped>" +
          "  thead > tr > td{border: 2px solid black;padding: 5px;font-size: 9px}" +
          "  tbody > tr > td{border: 2px solid black;padding: 5px;font-size: 9px}" +
          "  tfoot > tr > td{border: 2px solid black;padding: 5px;font-size: 9px}" +
          "@font-face {" +
          '  font-family: "IRANSans(FaNum)";' +
          '  src: url("https://abr.abriron.com/font/IRANSans(FaNum).ttf") format("truetype");' +
          "}" +
          '  body{font-family: "IRANSans(FaNum)";}' +
          "@page {" +
          "    padding: 0mm;" +
          "    margin: 0mm;" +
          " }" +
          " @media print {" +
          "    margin: 0mm; padding: 0mm" +
          "}" +
          "" +
          "</style>" +
          "" +
          "</head>" +
          '<body style="direction: rtl;">' +
          body +
          "</body>" +
          "</html>";

        const message = {
          Data: html,
          PrinterName: this.selectedPrinter,
        };
        socket.send(JSON.stringify(message));

        socket.onmessage = (event) => {
          // console.log('socket Response : ' + event.data)
          this.socketPrintRes = {
            status: event.data,
            timestamp: Date.now(),
            type: type ? type : "create",
          };
        };
      };

      socket.onclose = (event) => {
        app.clearForm();
      };
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.nextPermission) {
      this.leavePage(to, from, next);
    } else {
      this.bottomNavigation = false;
      next();
    }
  },
};
</script>
<style scoped>
::v-deep .v-btn--icon.v-size--small .v-icon {
  margin-top: 8px;
}
::v-deep .v-input--selection-controls__ripple {
  display: none;
}
.print-button {
  border: 1px solid silver;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.v-btn--is-elevated {
  box-shadow: none !important;
}
.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
::v-deep .v-input__slot {
  margin-bottom: 0;
}
::v-deep .v-messages {
  display: none;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
}
.v-application .overflow-y-auto {
  overflow-y: unset !important;
}
.fullscreen {
  position: fixed;
  top: 0px;
  z-index: 8;
  right: 0px;
  height: 100%;
}
.sum-td {
  text-align: center;
  font-size: 30px !important;
  color: white;
  background-color: #009688;
}
.fixed-bottom-payment {
  border-top: 1px solid silver;
}
.fullscreen .fixed-bottom-payment {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.fixed-bottom-payment .wrapper-toggle-tax {
  border: 1px solid silver;
  border-radius: 4px;
}
.fixed-bottom-payment .wrapper-toggle-tax .child {
  padding: 7.5px;
  cursor: pointer;
}
.fixed-bottom-payment .wrapper-toggle-tax .child:first-child {
  border-left: 1px solid silver !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.fixed-bottom-payment .wrapper-toggle-tax .child:nth-child(2) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.fixed-bottom-payment .header-total {
  border: 1.5px solid #0066ff;
  padding: 0 5px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.v-card__text {
  width: auto;
}
.fixed-bottom-payment .body-total {
  border: 1.5px solid silver;
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
::v-deep .v-tabs--vertical > .v-window {
  margin-right: 30px;
}
.box {
  border: 1px solid silver;
  background-color: #f5f2f270;
  border-radius: 4px;
}
::v-deep .v-data-table.pos-table .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.pos-table {
  border: 1px solid silver;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver !important;
  padding: 0 9px;
  color: black;
  height: 40px !important;
}
::v-deep
  .v-data-table.pos-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep
  .v-data-table.pos-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver !important;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.pos-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
::v-deep .v-text-field--outlined.pos-device .v-label,
::v-deep .v-text-field--outlined.printer-device .v-label {
  top: 6px !important;
}
::v-deep .v-text-field.pos-device .v-label--active,
::v-deep .v-text-field.printer-device .v-label--active {
  top: 17px !important;
}
::v-deep .v-text-field--enclosed.pos-device .v-input__append-inner,
::v-deep .v-text-field--enclosed.printer-device .v-input__append-inner {
  margin-top: 5px;
}
::v-deep .v-text-field--outlined.printer-device .v-input__slot {
  margin-bottom: 4px !important;
}
</style>
